var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _g, _defs, _g2, _defs2, _g3, _defs3, _path, _path2, _path3, _g4, _defs4, _g5, _defs5, _path4, _g6, _defs6, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpriteicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icontext",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12849_8774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97943 9.41211C8.97943 11.4913 10.665 13.1768 12.7441 13.1768V16.0003C9.10555 16.0003 6.1559 13.0507 6.1559 9.41211H8.97943Z",
    fill: "url(#paint0_linear_12849_8774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97943 9.41217C8.97943 7.33298 10.665 5.64746 12.7441 5.64746V9.41217H8.97943Z",
    fill: "url(#paint1_linear_12849_8774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33238 9.41177C3.33238 4.21379 7.54616 0 12.7441 0V2.82353C9.10555 2.82353 6.1559 5.77319 6.1559 9.41177H3.33238Z",
    fill: "url(#paint2_linear_12849_8774)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12849_8774",
    x1: 0.273552,
    y1: 27.5298,
    x2: 13.6853,
    y2: 12.7062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.100849,
    stopColor: "#F660BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201698,
    stopColor: "#EC53CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302547,
    stopColor: "#E045DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403396,
    stopColor: "#D335EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504245,
    stopColor: "#C323FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603396,
    stopColor: "#B53AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702547,
    stopColor: "#A749FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801698,
    stopColor: "#9854FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900849,
    stopColor: "#865EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12849_8774",
    x1: 3.56767,
    y1: 11.0704,
    x2: 17.3481,
    y2: 8.71961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF881B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12849_8774",
    x1: 8.03826,
    y1: 0,
    x2: 8.03826,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200D97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12849_8774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "webcom-logo-short",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1748 3.30176H11.4456C10.8375 3.30176 10.2 3.80502 10.0169 4.43598L8.00204 11.5643L5.98721 4.43598C5.81137 3.81253 5.17396 3.30176 4.56584 3.30176H0.829254C0.221143 3.30176 -0.130536 3.81253 0.0453032 4.43598L2.06013 11.5643C2.23597 12.1877 2.87339 12.6985 3.48883 12.6985H7.21809C7.61373 12.6985 7.89947 12.4807 8.00204 12.1577C8.10461 12.4807 8.39035 12.6985 8.78599 12.6985H12.5153C13.1234 12.6985 13.7608 12.1952 13.9366 11.5643L15.9515 4.43598C16.1346 3.81253 15.7829 3.30176 15.1748 3.30176Z",
    fill: "url(#paint0_linear_12849_8757)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44951 3.30146C6.14912 3.30146 5.81209 3.48173 5.57031 3.74463C5.76813 3.93241 5.92199 4.17278 5.98793 4.42816L8.00276 11.5565L10.0176 4.42816C10.0982 4.15024 10.2374 3.9249 10.4572 3.72961C10.2154 3.48924 9.92967 3.29395 9.64393 3.29395H6.44951V3.30146Z",
    fill: "url(#paint1_linear_12849_8757)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3207 11.5717L10.8809 4.44337C10.8077 4.18799 10.6685 3.92509 10.4633 3.7373C10.2362 3.9326 10.097 4.18048 10.0237 4.43586L8.00156 11.5642V11.5717L5.98673 4.44337C5.91346 4.18799 5.76693 3.94011 5.56178 3.75233C5.35664 3.94011 5.20278 4.18799 5.12951 4.44337L2.68974 11.5717C2.49925 12.1951 2.88023 12.7059 3.5323 12.7059H7.21761C7.61325 12.7059 7.89898 12.4956 8.00156 12.1726C8.10413 12.4956 8.38987 12.7059 8.78551 12.7059H12.4708C13.1302 12.6984 13.5039 12.1951 13.3207 11.5717Z",
    fill: "url(#paint2_linear_12849_8757)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12849_8757",
    x1: 8.00381,
    y1: 10.1362,
    x2: 8.00381,
    y2: 2.80738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12849_8757",
    x1: 8.01179,
    y1: 9.27383,
    x2: 8.01179,
    y2: 3.09461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12849_8757",
    x1: 8.00357,
    y1: 12.7225,
    x2: 8.00357,
    y2: 5.68157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DE23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00974A"
  }))))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "webcom-logo-with-bg",
    width: 168,
    height: 36,
    viewBox: "0 0 168 36",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4704 2.946C17.4582 1.12697 19.3221 0.000386577 21.3437 0.000386577L165.203 0C167.337 0 168.682 2.3674 167.64 4.28713L151.46 33.054C150.472 34.873 148.608 35.9996 146.586 35.9996L2.79675 36C0.66317 36 -0.682375 33.6326 0.360101 31.7129L16.4704 2.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.885 10.812H39.3493C38.4466 10.812 37.5004 11.582 37.2285 12.5474L34.2377 23.4537L31.2468 12.5474C30.9858 11.5935 30.0396 10.812 29.1369 10.812H23.5903C22.6876 10.812 22.1656 11.5935 22.4266 12.5474L25.4174 23.4537C25.6785 24.4076 26.6247 25.1891 27.5382 25.1891H33.074C33.6613 25.1891 34.0854 24.8558 34.2377 24.3616C34.3899 24.8558 34.8141 25.1891 35.4014 25.1891H40.9371C41.8398 25.1891 42.786 24.4191 43.047 23.4537L46.0378 12.5474C46.3097 11.5935 45.7877 10.812 44.885 10.812Z",
    fill: "url(#paint0_linear_12717_4971)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9301 10.8115C31.4842 10.8115 30.9839 11.0873 30.625 11.4895C30.9186 11.7768 31.147 12.1446 31.2449 12.5353L34.2357 23.4416L37.2266 12.5353C37.3462 12.1101 37.5528 11.7654 37.8791 11.4665C37.5202 11.0988 37.0961 10.8 36.6719 10.8H31.9301V10.8115Z",
    fill: "url(#paint1_linear_12717_4971)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1348 23.4646L38.5132 12.5583C38.4045 12.1675 38.1978 11.7653 37.8933 11.478C37.5562 11.7768 37.3495 12.156 37.2408 12.5468L34.2391 23.4531V23.4646L31.2482 12.5583C31.1395 12.1675 30.922 11.7883 30.6174 11.501C30.3129 11.7883 30.0845 12.1675 29.9758 12.5583L26.3542 23.4646C26.0714 24.4185 26.6369 25.1999 27.6049 25.1999H33.0754C33.6626 25.1999 34.0868 24.8782 34.2391 24.384C34.3913 24.8782 34.8155 25.1999 35.4028 25.1999H40.8733C41.8521 25.1885 42.4067 24.4185 42.1348 23.4646Z",
    fill: "url(#paint2_linear_12717_4971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8726 13.0357L59.5895 21.2887L57.5473 13.8673C57.4712 13.5775 57.4585 13.4263 57.078 13.4263H56.3677C55.9999 13.4263 55.9745 13.5775 55.8984 13.8673L53.8436 21.2887L51.5731 13.0357L50.3047 13.3507L52.9176 22.4983C52.9937 22.7755 53.0445 22.9393 53.4123 22.9393H54.1353C54.5031 22.9393 54.5539 22.7755 54.63 22.4983L56.7102 15.0895L58.803 22.4983C58.8791 22.7881 58.9172 22.9393 59.2977 22.9393H60.0207C60.4012 22.9393 60.4393 22.7881 60.5154 22.4983L63.1156 13.3507L61.8726 13.0357ZM67.9356 16.2739C67.3648 15.9589 66.8194 15.9211 66.1091 15.9211C65.5637 15.9211 64.8026 15.9337 64.2953 16.1605C63.2044 16.6645 62.9888 17.9875 62.9888 19.0585V19.8775C62.9888 20.9485 63.1917 22.1455 64.1431 22.6495C64.6758 22.9267 65.3734 23.0149 66.0457 23.0149C66.7813 23.0149 67.8214 22.9393 68.4049 22.8259L68.3161 21.8935C67.517 22.0069 66.6545 22.0447 66.2613 22.0447C65.8935 22.0447 65.0563 21.9943 64.6758 21.6793C64.3206 21.3769 64.2065 20.7091 64.1938 19.9027H68.0498C68.6459 19.9027 68.9123 19.6129 68.9123 19.2349V18.5167C68.925 17.2441 68.443 16.5637 67.9356 16.2739ZM67.72 18.9577H64.1938C64.1938 18.1009 64.3333 17.5087 64.7011 17.1685C65.0436 16.8535 65.7286 16.8535 66.071 16.8535C66.515 16.8535 66.9716 16.8913 67.2633 17.1307C67.5804 17.4079 67.72 17.9119 67.72 18.6805C67.72 18.9073 67.72 18.7561 67.72 18.9577ZM74.4045 16.1983C73.783 15.9211 73.0092 15.9211 72.4511 15.9211C72.1214 15.9211 71.4618 15.9841 70.9037 16.0723V12.9601H69.6987V21.2887C69.6987 22.7629 70.9417 23.0401 72.6034 23.0401C74.6328 23.0401 75.6222 22.5613 75.6222 19.6129V18.9577C75.6349 17.8867 75.508 16.6897 74.4045 16.1983ZM74.4172 19.7011C74.4172 21.7171 74.1128 22.1077 72.7302 22.1077C72.1214 22.1077 71.6267 22.0573 71.3476 21.8935C71.0052 21.6919 70.9037 21.3643 70.9037 20.8729V17.0677C71.4618 16.9417 72.1721 16.9039 72.5019 16.9039C74.0367 16.9039 74.4045 17.1811 74.4045 18.8695V19.7011H74.4172ZM79.4908 22.0447C79.123 22.0447 78.3366 22.0447 78.0195 21.7423C77.6516 21.4021 77.5375 20.7973 77.5375 19.9657V18.9703C77.5375 18.1387 77.6389 17.5339 78.0195 17.1937C78.3366 16.9039 79.1103 16.8913 79.4908 16.8913C79.884 16.8913 80.4421 16.9165 81.2412 17.0425C81.2412 17.0425 81.33 16.1353 81.33 16.1101C80.7465 16.0093 79.8206 15.9211 79.2752 15.9211C78.7551 15.9211 78.0195 15.9715 77.4867 16.2487C76.5227 16.7527 76.2944 17.9875 76.2944 19.0585V19.8649C76.2944 20.9359 76.5227 22.1707 77.4867 22.6747C78.0195 22.9519 78.7551 23.0023 79.2752 23.0023C79.8206 23.0023 80.8734 22.9267 81.4695 22.8133L81.3808 21.8809C80.569 22.0195 79.8713 22.0447 79.4908 22.0447ZM86.7715 16.1479C86.2641 15.9211 85.5538 15.9211 85.0084 15.9211C84.463 15.9211 83.7527 15.9211 83.2453 16.1479C82.1545 16.6519 82.0276 17.9875 82.0276 19.0585V19.8775C82.0276 20.9485 82.1418 22.3093 83.2453 22.7881C83.74 23.0149 84.463 23.0149 85.0084 23.0149C85.5538 23.0149 86.2641 23.0149 86.7715 22.7881C87.8623 22.2841 87.9892 20.9485 87.9892 19.8775V19.0585C87.9892 17.9875 87.8623 16.6519 86.7715 16.1479ZM86.7715 19.9783C86.7715 20.8099 86.7461 21.4525 86.3783 21.7927C86.0612 22.0951 85.3763 22.0825 85.0084 22.0951C84.6279 22.0951 83.9556 22.0951 83.6385 21.7927C83.2834 21.4525 83.258 20.8099 83.258 19.9783V18.9703C83.258 18.1387 83.2707 17.4961 83.6385 17.1559C83.9556 16.8661 84.6406 16.8535 85.0084 16.8535C85.3763 16.8535 86.0612 16.8661 86.3783 17.1559C86.7335 17.4961 86.7715 18.1387 86.7715 18.9703V19.9783ZM95.9675 15.9211C94.9908 15.9211 93.7985 16.1983 93.4053 16.2991C92.9613 16.0093 92.3652 15.9211 91.6929 15.9211C90.8938 15.9211 89.8791 16.0597 89.3337 16.1605C89.1561 16.1983 88.7502 16.2991 88.7502 16.8535V22.9393H89.9552V17.1055C90.3865 17.0173 90.9826 16.9039 91.49 16.9039C92.6569 16.9039 93.0248 17.3071 93.0248 18.3781V22.9393H94.2298V18.2773C94.2298 17.8111 94.1663 17.4331 94.0395 17.1181C94.5215 17.0173 95.1684 16.8913 95.7645 16.8913C96.9188 16.8913 97.2993 17.2945 97.2993 18.3655V22.9267H98.5043V18.2773C98.4916 16.2865 97.4008 15.9211 95.9675 15.9211Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.069 9.36011L101.289 26.6401H102.337L112.117 9.36011H111.069Z",
    fill: "#B6CAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.353 18.3242V21.4435C121.815 22.5168 120.643 23.0534 118.871 23.087C116.37 22.9528 115.041 21.5106 114.914 18.7602C115.041 16.0099 116.307 14.5342 118.713 14.4C120.548 14.4335 121.751 15.1714 122.321 16.6472L121.15 17.0832C120.77 16.0099 119.947 15.4733 118.713 15.4733C117.161 15.641 116.338 16.7143 116.18 18.7267C116.275 20.7727 117.161 21.8795 118.839 22.0137C119.947 21.9801 120.738 21.6447 121.213 20.9739V19.3304H118.618V18.2571H122.353V18.3242Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.601 19.8V22.9193H123.43V16.882H124.601V18.0224C124.886 17.1839 125.392 16.7478 126.12 16.7143C126.468 16.7143 126.817 16.8149 127.165 17.0497L126.753 18.1565C126.532 17.9553 126.279 17.8547 125.93 17.8547C125.076 17.9217 124.633 18.5926 124.601 19.8Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.171 16.7816C131.975 16.8487 132.925 17.922 132.988 19.9679C132.925 21.9803 131.975 23.0201 130.076 23.0872C128.272 22.9866 127.322 21.9468 127.195 20.0015C127.322 17.922 128.303 16.8487 130.171 16.7816ZM130.139 22.1816C131.215 22.148 131.785 21.4102 131.817 19.9679C131.753 18.5592 131.215 17.8213 130.139 17.7543C129.031 17.7878 128.461 18.5257 128.43 19.9679C128.461 21.4102 129.031 22.148 130.139 22.1816Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.035 22.9193H137.864V21.8796C137.452 22.651 136.819 23.0535 135.965 23.0535C134.54 23.0535 133.844 22.2485 133.844 20.6721V16.882H135.015V20.5715C135.015 21.6448 135.458 22.1814 136.376 22.1814C137.294 22.1143 137.8 21.5106 137.895 20.4038V16.882H139.067V22.9193H139.035Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.406 22.1145V25.2002H140.203V16.8822H141.406V17.922C141.754 17.1505 142.387 16.7816 143.337 16.7816C144.825 16.8487 145.584 17.8884 145.648 19.9008C145.616 22.0139 144.825 23.0872 143.274 23.0872C142.451 23.0536 141.817 22.7518 141.406 22.1145ZM141.374 19.5654V20.2698C141.406 21.5108 141.912 22.148 142.925 22.2151C143.97 22.2151 144.476 21.4772 144.476 19.9679C144.445 18.5592 143.907 17.8213 142.894 17.7878C141.944 17.8213 141.438 18.4251 141.374 19.5654Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12717_4971",
    x1: 34.2403,
    y1: 21.2688,
    x2: 34.2403,
    y2: 10.0556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12717_4971",
    x1: 34.2492,
    y1: 19.9492,
    x2: 34.2492,
    y2: 10.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12717_4971",
    x1: 34.242,
    y1: 25.2254,
    x2: 34.242,
    y2: 14.4527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DE23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00974A"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "webcom-logo",
    width: 170,
    height: 34,
    viewBox: "0 0 170 34",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2465 7.01697H24.3218C23.0296 7.01697 21.6751 8.0864 21.2858 9.42718L17.0043 24.5748L12.7228 9.42718C12.3492 8.10236 10.9947 7.01697 9.70242 7.01697H1.76217C0.469928 7.01697 -0.27739 8.10236 0.0962693 9.42718L4.37778 24.5748C4.75144 25.8996 6.10595 26.985 7.41376 26.985H15.3384C16.1792 26.985 16.7864 26.5222 17.0043 25.8358C17.2223 26.5222 17.8295 26.985 18.6702 26.985H26.5949C27.8872 26.985 29.2417 25.9156 29.6153 24.5748L33.8968 9.42718C34.2861 8.10236 33.5388 7.01697 32.2465 7.01697Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7042 7.01596C13.0659 7.01596 12.3497 7.39904 11.8359 7.9577C12.2563 8.35674 12.5833 8.86752 12.7234 9.41022L17.0049 24.5579L21.2864 9.41022C21.4577 8.81963 21.7535 8.34078 22.2205 7.92578C21.7068 7.415 21.0996 7 20.4924 7H13.7042V7.01596Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3085 24.5898L23.1239 9.44211C22.9682 8.89941 22.6724 8.34075 22.2365 7.94171C21.7538 8.35672 21.458 8.88345 21.3023 9.42615L17.0053 24.5738V24.5898L12.7238 9.44211C12.5681 8.89941 12.2567 8.37268 11.8207 7.97363C11.3848 8.37268 11.0579 8.89941 10.9022 9.44211L5.71765 24.5898C5.31285 25.9146 6.12245 27 7.5081 27H15.3394C16.1801 27 16.7873 26.553 17.0053 25.8667C17.2232 26.553 17.8304 27 18.6712 27H26.5024C27.9037 26.984 28.6977 25.9146 28.3085 24.5898Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.56 10.105L53.2916 21.5675L50.3682 11.26C50.2592 10.8575 50.2411 10.6475 49.6963 10.6475H48.6795C48.1529 10.6475 48.1166 10.8575 48.0076 11.26L45.0661 21.5675L41.8158 10.105L40 10.5425L43.7405 23.2475C43.8495 23.6325 43.9221 23.86 44.4487 23.86H45.4837C46.0103 23.86 46.0829 23.6325 46.1918 23.2475L49.1697 12.9575L52.1658 23.2475C52.2747 23.65 52.3292 23.86 52.874 23.86H53.909C54.4537 23.86 54.5082 23.65 54.6171 23.2475L58.3395 10.5425L56.56 10.105ZM65.2395 14.6025C64.4224 14.165 63.6416 14.1125 62.6248 14.1125C61.844 14.1125 60.7545 14.13 60.0282 14.445C58.4666 15.145 58.1579 16.9825 58.1579 18.47V19.6075C58.1579 21.095 58.4484 22.7575 59.8103 23.4575C60.5729 23.8425 61.5716 23.965 62.534 23.965C63.5871 23.965 65.0761 23.86 65.9113 23.7025L65.7842 22.4075C64.6403 22.565 63.4055 22.6175 62.8426 22.6175C62.3161 22.6175 61.1176 22.5475 60.5729 22.11C60.0645 21.69 59.9011 20.7625 59.8829 19.6425H65.4029C66.2563 19.6425 66.6377 19.24 66.6377 18.715V17.7175C66.6558 15.95 65.9658 15.005 65.2395 14.6025ZM64.9308 18.33H59.8829C59.8829 17.14 60.0826 16.3175 60.6092 15.845C61.0995 15.4075 62.08 15.4075 62.5703 15.4075C63.2058 15.4075 63.8595 15.46 64.2771 15.7925C64.7311 16.1775 64.9308 16.8775 64.9308 17.945C64.9308 18.26 64.9308 18.05 64.9308 18.33ZM74.5 14.4975C73.6103 14.1125 72.5027 14.1125 71.7037 14.1125C71.2316 14.1125 70.2874 14.2 69.4884 14.3225V10H67.7634V21.5675C67.7634 23.615 69.5429 24 71.9216 24C74.8269 24 76.2432 23.335 76.2432 19.24V18.33C76.2613 16.8425 76.0798 15.18 74.5 14.4975ZM74.5182 19.3625C74.5182 22.1625 74.0824 22.705 72.1032 22.705C71.2316 22.705 70.5234 22.635 70.124 22.4075C69.6337 22.1275 69.4884 21.6725 69.4884 20.99V15.705C70.2874 15.53 71.3042 15.4775 71.7763 15.4775C73.9734 15.4775 74.5 15.8625 74.5 18.2075V19.3625H74.5182ZM81.7813 22.6175C81.2548 22.6175 80.129 22.6175 79.675 22.1975C79.1484 21.725 78.985 20.885 78.985 19.73V18.3475C78.985 17.1925 79.1303 16.3525 79.675 15.88C80.129 15.4775 81.2366 15.46 81.7813 15.46C82.3442 15.46 83.1432 15.495 84.2871 15.67C84.2871 15.67 84.4142 14.41 84.4142 14.375C83.579 14.235 82.2535 14.1125 81.4727 14.1125C80.7282 14.1125 79.675 14.1825 78.9124 14.5675C77.5324 15.2675 77.2056 16.9825 77.2056 18.47V19.59C77.2056 21.0775 77.5324 22.7925 78.9124 23.4925C79.675 23.8775 80.7282 23.9475 81.4727 23.9475C82.2535 23.9475 83.7606 23.8425 84.614 23.685L84.4869 22.39C83.3248 22.5825 82.3261 22.6175 81.7813 22.6175ZM92.204 14.4275C91.4777 14.1125 90.4608 14.1125 89.68 14.1125C88.8993 14.1125 87.8824 14.1125 87.1561 14.4275C85.5945 15.1275 85.4129 16.9825 85.4129 18.47V19.6075C85.4129 21.095 85.5764 22.985 87.1561 23.65C87.8643 23.965 88.8993 23.965 89.68 23.965C90.4608 23.965 91.4777 23.965 92.204 23.65C93.7656 22.95 93.9472 21.095 93.9472 19.6075V18.47C93.9472 16.9825 93.7656 15.1275 92.204 14.4275ZM92.204 19.7475C92.204 20.9025 92.1677 21.795 91.6411 22.2675C91.1871 22.6875 90.2066 22.67 89.68 22.6875C89.1353 22.6875 88.1729 22.6875 87.719 22.2675C87.2106 21.795 87.1742 20.9025 87.1742 19.7475V18.3475C87.1742 17.1925 87.1924 16.3 87.719 15.8275C88.1729 15.425 89.1535 15.4075 89.68 15.4075C90.2066 15.4075 91.1871 15.425 91.6411 15.8275C92.1495 16.3 92.204 17.1925 92.204 18.3475V19.7475ZM105.368 14.1125C103.97 14.1125 102.263 14.4975 101.701 14.6375C101.065 14.235 100.212 14.1125 99.2493 14.1125C98.1053 14.1125 96.6527 14.305 95.8719 14.445C95.6177 14.4975 95.0366 14.6375 95.0366 15.4075V23.86H96.7616V15.7575C97.379 15.635 98.2324 15.4775 98.9587 15.4775C100.629 15.4775 101.156 16.0375 101.156 17.525V23.86H102.881V17.385C102.881 16.7375 102.79 16.2125 102.608 15.775C103.298 15.635 104.225 15.46 105.078 15.46C106.73 15.46 107.275 16.02 107.275 17.5075V23.8425H109V17.385C108.982 14.62 107.42 14.1125 105.368 14.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 0H118V34H117L117 0Z",
    fill: "#B6CAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.649 17.4503V21.7826C135.878 23.2733 134.202 24.0186 131.664 24.0652C128.084 23.8789 126.181 21.8758 126 18.0559C126.181 14.236 127.994 12.1863 131.438 12C134.066 12.0466 135.788 13.0714 136.604 15.1211L134.927 15.7267C134.383 14.236 133.205 13.4907 131.438 13.4907C129.217 13.7236 128.039 15.2143 127.813 18.0093C127.949 20.8509 129.217 22.3882 131.619 22.5745C133.205 22.528 134.338 22.0621 135.018 21.1304V18.8478H131.302V17.3571H136.649V17.4503Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.864 19.5V23.8323H138.188V15.4472H139.864V17.0311C140.272 15.8665 140.997 15.2609 142.039 15.2143C142.538 15.2143 143.036 15.354 143.535 15.6801L142.945 17.2174C142.628 16.9379 142.266 16.7981 141.767 16.7981C140.544 16.8913 139.909 17.823 139.864 19.5Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.842 15.3075C150.424 15.4007 151.784 16.8913 151.875 19.733C151.784 22.528 150.424 23.9721 147.706 24.0653C145.123 23.9255 143.763 22.4814 143.582 19.7795C143.763 16.8913 145.168 15.4007 147.842 15.3075ZM147.796 22.8075C149.337 22.7609 150.153 21.7361 150.198 19.733C150.107 17.7764 149.337 16.7516 147.796 16.6584C146.21 16.705 145.395 17.7299 145.349 19.733C145.395 21.7361 146.21 22.7609 147.796 22.8075Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.529 23.8323H158.853V22.3882C158.263 23.4596 157.357 24.0186 156.134 24.0186C154.095 24.0186 153.098 22.9006 153.098 20.7112V15.4472H154.774V20.5714C154.774 22.0621 155.409 22.8075 156.723 22.8075C158.037 22.7143 158.762 21.8758 158.898 20.3385V15.4472H160.574V23.8323H160.529Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.929 22.7143V27H162.207V15.4472H163.929V16.8913C164.427 15.8199 165.334 15.3075 166.693 15.3075C168.823 15.4007 169.91 16.8448 170.001 19.6398C169.956 22.5746 168.823 24.0653 166.602 24.0653C165.424 24.0187 164.518 23.5994 163.929 22.7143ZM163.884 19.174V20.1522C163.929 21.8758 164.654 22.7609 166.104 22.8541C167.599 22.8541 168.324 21.8292 168.324 19.733C168.279 17.7764 167.509 16.7516 166.059 16.705C164.699 16.7516 163.974 17.5901 163.884 19.174Z",
    fill: "#00B9FF"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.0081,
    y1: 21.5402,
    x2: 17.0081,
    y2: 5.96642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17.0241,
    y1: 19.7073,
    x2: 17.0241,
    y2: 6.57641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 17.0095,
    y1: 27.0353,
    x2: 17.0095,
    y2: 12.0733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DE23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00974A"
  }))))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "phone-old",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.9378,
    d: "M30.221 23.074v4.282c0.002 0.398-0.080 0.791-0.239 1.155s-0.394 0.691-0.687 0.96c-0.294 0.269-0.64 0.473-1.017 0.601s-0.777 0.175-1.174 0.139c-4.401-0.477-8.628-1.978-12.342-4.382-3.456-2.191-6.385-5.115-8.581-8.564-2.417-3.724-3.921-7.963-4.391-12.375-0.036-0.395 0.011-0.793 0.138-1.168s0.33-0.721 0.598-1.013c0.268-0.293 0.594-0.527 0.957-0.687s0.756-0.243 1.153-0.243h4.291c0.694-0.007 1.367 0.238 1.893 0.69s0.87 1.079 0.967 1.765c0.181 1.37 0.517 2.716 1.001 4.011 0.192 0.511 0.234 1.066 0.12 1.6s-0.379 1.024-0.764 1.412l-1.816 1.813c2.036 3.573 5.001 6.532 8.581 8.564l1.816-1.813c0.389-0.384 0.88-0.648 1.415-0.762s1.091-0.072 1.603 0.12c1.298 0.483 2.646 0.819 4.019 0.999 0.695 0.098 1.329 0.447 1.783 0.981s0.695 1.216 0.677 1.916z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "sms-old",
    fill: "currentColor",
    className: "bi bi-chat-left-dots",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "clock-old",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
    stroke: "currentColor",
    strokeWidth: 1.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.20001V9.00001L12.2 10.6",
    stroke: "currentColor",
    strokeWidth: 1.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "checked-old",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell-old",
    viewBox: "0 0 16 18",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.80085C12.6667 4.52759 12.175 3.30647 11.2998 2.40614C10.4247 1.5058 9.23768 1 8 1C6.76232 1 5.57534 1.5058 4.70017 2.40614C3.825 3.30647 3.33333 4.52759 3.33333 5.80085C3.33333 11.4018 1 13.0021 1 13.0021H15C15 13.0021 12.6667 11.4018 12.6667 5.80085Z",
    stroke: "currentColor",
    strokeWidth: 1.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34736 16.2031C9.21062 16.4456 9.01435 16.6469 8.7782 16.7869C8.54206 16.9268 8.27432 17.0004 8.00181 17.0004C7.72929 17.0004 7.46155 16.9268 7.22541 16.7869C6.98926 16.6469 6.79299 16.4456 6.65625 16.2031",
    stroke: "currentColor",
    strokeWidth: 1.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "person-old",
    viewBox: "0 0 14 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 3.89744C4.4 2.42468 5.56406 1.23077 7 1.23077C8.43594 1.23077 9.6 2.42468 9.6 3.89744C9.6 5.3702 8.43594 6.5641 7 6.5641C5.56406 6.5641 4.4 5.3702 4.4 3.89744ZM7 0C4.90132 0 3.2 1.74494 3.2 3.89744C3.2 6.04993 4.90132 7.79487 7 7.79487C9.09868 7.79487 10.8 6.04993 10.8 3.89744C10.8 1.74494 9.09868 0 7 0ZM3.8 9.84615C2.79218 9.84615 1.82563 10.2568 1.11299 10.9877C0.400356 11.7186 0 12.7099 0 13.7436V15.3846C0 15.7245 0.268629 16 0.6 16C0.931371 16 1.2 15.7245 1.2 15.3846V13.7436C1.2 13.0363 1.47393 12.3581 1.96152 11.858C2.44912 11.3579 3.11044 11.0769 3.8 11.0769H10.2C10.8896 11.0769 11.5509 11.3579 12.0385 11.858C12.5261 12.3581 12.8 13.0363 12.8 13.7436V15.3846C12.8 15.7245 13.0686 16 13.4 16C13.7314 16 14 15.7245 14 15.3846V13.7436C14 12.7099 13.5996 11.7186 12.887 10.9877C12.1744 10.2568 11.2078 9.84615 10.2 9.84615H3.8Z",
    fill: "currentColor"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "play-old",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37143 8C1.37143 4.33914 4.33914 1.37143 8 1.37143C11.6609 1.37143 14.6286 4.33914 14.6286 8C14.6286 11.6609 11.6609 14.6286 8 14.6286C4.33914 14.6286 1.37143 11.6609 1.37143 8ZM8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM6.91751 4.50378C6.70709 4.3635 6.43655 4.35043 6.21358 4.46975C5.99062 4.58908 5.85143 4.82144 5.85143 5.07433V10.9258C5.85143 11.1786 5.99062 11.411 6.21358 11.5303C6.43655 11.6497 6.70709 11.6366 6.91751 11.4963L11.3061 8.57059C11.4968 8.44342 11.6114 8.22932 11.6114 8.00004C11.6114 7.77077 11.4968 7.55667 11.3061 7.4295L6.91751 4.50378ZM9.68953 8.00004L7.22286 9.64449V6.3556L9.68953 8.00004Z",
    fill: "currentColor"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings-old",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4379 1.34911C7.58698 1.20003 7.78917 1.11628 8 1.11628C8.21083 1.11628 8.41302 1.20003 8.5621 1.34911C8.71118 1.49819 8.79493 1.70038 8.79493 1.91121V1.97209L8.79493 1.97432C8.79623 2.30087 8.89299 2.61991 9.0733 2.89217C9.25305 3.1636 9.50801 3.37672 9.80697 3.50548C10.1123 3.6396 10.4508 3.67948 10.779 3.61997C11.1082 3.56028 11.412 3.40334 11.6512 3.16939L11.6512 3.16942L11.6556 3.16506L11.6961 3.12447L11.6964 3.12425C11.7702 3.05035 11.8579 2.99171 11.9544 2.95171C12.0509 2.9117 12.1543 2.89111 12.2588 2.89111C12.3632 2.89111 12.4667 2.9117 12.5632 2.95171C12.6597 2.99171 12.7474 3.05034 12.8212 3.12425L12.8216 3.12469C12.8955 3.19852 12.9542 3.28619 12.9942 3.38269C13.0342 3.4792 13.0548 3.58264 13.0548 3.6871C13.0548 3.79157 13.0342 3.89501 12.9942 3.99151C12.9542 4.08801 12.8955 4.17569 12.8216 4.24951L12.8214 4.24973L12.7808 4.29033L12.7808 4.2903L12.7765 4.2947C12.5425 4.53387 12.3856 4.83764 12.3259 5.16683C12.2733 5.45681 12.2983 5.75482 12.3974 6.03091C12.4033 6.0857 12.4174 6.13941 12.4392 6.19027C12.5679 6.49042 12.7814 6.7464 13.0537 6.9267C13.326 7.10701 13.645 7.20377 13.9716 7.20507L13.9738 7.20507H14.0888C14.2996 7.20507 14.5018 7.28882 14.6509 7.4379C14.8 7.58698 14.8837 7.78917 14.8837 8C14.8837 8.21083 14.8 8.41302 14.6509 8.5621C14.5018 8.71118 14.2996 8.79493 14.0888 8.79493L14.0279 8.79492L14.0257 8.79493C13.6991 8.79623 13.3801 8.89299 13.1078 9.0733C12.8364 9.25305 12.6233 9.50802 12.4945 9.80699C12.3604 10.1124 12.3205 10.4508 12.38 10.779C12.4397 11.1082 12.5967 11.412 12.8306 11.6512L12.8306 11.6512L12.8349 11.6556L12.8755 11.6961L12.8757 11.6964C12.9497 11.7702 13.0083 11.8579 13.0483 11.9544C13.0883 12.0509 13.1089 12.1543 13.1089 12.2588C13.1089 12.3632 13.0883 12.4667 13.0483 12.5632C13.0083 12.6597 12.9497 12.7474 12.8757 12.8212L12.8753 12.8216C12.8015 12.8955 12.7138 12.9542 12.6173 12.9942C12.5208 13.0342 12.4174 13.0548 12.3129 13.0548C12.2084 13.0548 12.105 13.0342 12.0085 12.9942C11.912 12.9542 11.8243 12.8955 11.7505 12.8216L11.7503 12.8214L11.7097 12.7808L11.7097 12.7808L11.7053 12.7765C11.4661 12.5425 11.1624 12.3856 10.8332 12.3259C10.505 12.2664 10.1665 12.3063 9.86111 12.4404C9.56215 12.5692 9.30718 12.7823 9.12742 13.0537C8.94712 13.326 8.85036 13.645 8.84905 13.9716L8.84905 13.9738V14.0888C8.84905 14.2996 8.7653 14.5018 8.61622 14.6509C8.46714 14.8 8.26495 14.8837 8.05412 14.8837C7.8433 14.8837 7.6411 14.8 7.49203 14.6509C7.34295 14.5018 7.2592 14.2996 7.2592 14.0888V14.0279L7.25904 14.0149C7.25119 13.679 7.14246 13.3532 6.947 13.0799C6.75497 12.8114 6.48793 12.6058 6.17958 12.4887C5.87774 12.3593 5.54436 12.3214 5.22095 12.38C4.89176 12.4397 4.58799 12.5967 4.34882 12.8306L4.3488 12.8306L4.34444 12.8349L4.30385 12.8755L4.30364 12.8757C4.22981 12.9497 4.14214 13.0083 4.04564 13.0483C3.94913 13.0883 3.84569 13.1089 3.74123 13.1089C3.63676 13.1089 3.53332 13.0883 3.43682 13.0483C3.34031 13.0083 3.25264 12.9497 3.17882 12.8757L3.17838 12.8753C3.10447 12.8015 3.04584 12.7138 3.00583 12.6173C2.96583 12.5208 2.94524 12.4174 2.94524 12.3129C2.94524 12.2084 2.96583 12.105 3.00583 12.0085C3.04584 11.912 3.10447 11.8243 3.17838 11.7505L3.1786 11.7503L3.21919 11.7097L3.21921 11.7097L3.22352 11.7053C3.45747 11.4661 3.6144 11.1624 3.67409 10.8332C3.7336 10.505 3.69373 10.1665 3.55961 9.86111C3.43085 9.56215 3.21772 9.30718 2.94629 9.12742C2.67403 8.94712 2.35499 8.85036 2.02844 8.84905H2.02622H1.91121C1.70038 8.84905 1.49819 8.7653 1.34911 8.61622C1.20003 8.46714 1.11628 8.26495 1.11628 8.05412C1.11628 7.8433 1.20003 7.6411 1.34911 7.49203C1.49819 7.34295 1.70038 7.2592 1.91121 7.2592H1.97209L1.98514 7.25904C2.32104 7.25119 2.6468 7.14246 2.92008 6.947C3.18857 6.75497 3.39421 6.48794 3.51131 6.17959C3.64075 5.87774 3.67861 5.54436 3.61997 5.22095C3.56028 4.89176 3.40334 4.58799 3.16939 4.34882L3.16942 4.3488L3.16507 4.34445L3.12447 4.30386L3.12425 4.30364C3.05035 4.22981 2.99171 4.14214 2.95171 4.04564C2.9117 3.94913 2.89111 3.84569 2.89111 3.74123C2.89111 3.63676 2.9117 3.53332 2.95171 3.43682C2.99171 3.34031 3.05035 3.25264 3.12425 3.17882L3.12469 3.17838C3.19852 3.10447 3.28619 3.04583 3.38269 3.00583C3.4792 2.96583 3.58264 2.94524 3.6871 2.94524C3.79157 2.94524 3.89501 2.96583 3.99151 3.00583C4.08802 3.04583 4.17569 3.10447 4.24951 3.17838L4.24973 3.1786L4.29033 3.21919L4.2903 3.21921L4.2947 3.22352C4.53387 3.45747 4.83764 3.6144 5.16683 3.67409C5.45681 3.72667 5.75482 3.70167 6.03091 3.60263C6.0857 3.59666 6.13941 3.58259 6.19027 3.56079C6.49042 3.43215 6.7464 3.21855 6.9267 2.94629C7.10701 2.67403 7.20377 2.35499 7.20507 2.02844L7.20507 2.02622V1.91121C7.20507 1.70038 7.28883 1.49819 7.4379 1.34911ZM13.517 10.255L13.0063 10.0296L13.5194 10.2495C13.5622 10.1494 13.6334 10.0641 13.7242 10.004C13.8147 9.94405 13.9207 9.91181 14.0292 9.91121H14.0888C14.5957 9.91121 15.0818 9.70985 15.4402 9.35143C15.7986 8.99301 16 8.50688 16 8C16 7.49312 15.7986 7.00699 15.4402 6.64857C15.0818 6.29015 14.5957 6.08879 14.0888 6.08879H13.9751C13.8666 6.08819 13.7606 6.05595 13.6701 5.99601C13.6019 5.95088 13.5448 5.89152 13.5024 5.82239C13.4947 5.77722 13.4814 5.73306 13.4628 5.69092C13.4178 5.5889 13.4044 5.47572 13.4243 5.36599C13.444 5.2571 13.4957 5.15657 13.5727 5.07713L13.6105 5.03928L13.6107 5.03906C13.7883 4.86161 13.9292 4.6509 14.0254 4.41898C14.1215 4.18697 14.171 3.93827 14.171 3.6871C14.171 3.43594 14.1215 3.18724 14.0254 2.95523C13.9292 2.72321 13.7882 2.51243 13.6105 2.33493C13.4331 2.15743 13.2225 2.01662 12.9907 1.92052C12.7586 1.82434 12.5099 1.77483 12.2588 1.77483C12.0076 1.77483 11.7589 1.82434 11.5269 1.92052C11.295 2.01666 11.0843 2.15755 10.9068 2.33515L10.9066 2.33537L10.8688 2.37319C10.7893 2.45019 10.6888 2.50186 10.5799 2.5216C10.4702 2.5415 10.357 2.52806 10.255 2.48304L10.255 2.48301L10.2495 2.48065C10.1494 2.43777 10.0641 2.36657 10.004 2.27582C9.94405 2.18531 9.91181 2.0793 9.91121 1.97076V1.91121C9.91121 1.40432 9.70985 0.918199 9.35143 0.559779C8.99301 0.201359 8.50688 0 8 0C7.49312 0 7.00699 0.201359 6.64857 0.559779C6.29015 0.918199 6.08879 1.40432 6.08879 1.91121V2.02488C6.08819 2.13342 6.05595 2.23943 5.99601 2.32994C5.95088 2.39809 5.89152 2.45521 5.82239 2.49759C5.77723 2.5053 5.73306 2.51856 5.69092 2.53716C5.5889 2.58219 5.47572 2.59562 5.36599 2.57572C5.25709 2.55598 5.15654 2.50431 5.0771 2.42731L5.03928 2.38949C4.86178 2.21179 4.651 2.07082 4.41898 1.97464C4.18696 1.87846 3.93827 1.82896 3.6871 1.82896C3.43594 1.82896 3.18724 1.87846 2.95523 1.97464C2.72331 2.07078 2.5126 2.21167 2.33515 2.38927C2.15755 2.56672 2.01666 2.77743 1.92052 3.00935C1.82434 3.24137 1.77483 3.49006 1.77483 3.74123C1.77483 3.99239 1.82434 4.24109 1.92052 4.4731C2.0167 4.70512 2.15767 4.9159 2.33537 5.0934L2.37318 5.13122C2.45019 5.21066 2.50186 5.31121 2.5216 5.42011C2.5415 5.52984 2.52806 5.64302 2.48304 5.74504C2.47829 5.7558 2.47388 5.76671 2.46982 5.77774C2.43116 5.88285 2.36178 5.9739 2.27069 6.03906C2.18106 6.10316 2.0745 6.13928 1.96445 6.14292H1.91121C1.40432 6.14292 0.918199 6.34428 0.559779 6.7027C0.201359 7.06112 0 7.54724 0 8.05412C0 8.56101 0.201359 9.04713 0.559779 9.40555C0.918199 9.76397 1.40432 9.96533 1.91121 9.96533H2.02488C2.13342 9.96593 2.23943 9.99817 2.32994 10.0581C2.42069 10.1182 2.49189 10.2035 2.53477 10.3036L2.53474 10.3036L2.53716 10.3091C2.58219 10.4111 2.59562 10.5243 2.57572 10.634C2.55598 10.7429 2.50431 10.8435 2.42731 10.9229L2.38949 10.9607L2.38931 10.9609L2.38927 10.9609C2.21167 11.1384 2.07078 11.3491 1.97464 11.581C1.87846 11.813 1.82896 12.0617 1.82896 12.3129C1.82896 12.5641 1.87846 12.8128 1.97464 13.0448C2.07074 13.2766 2.21156 13.4872 2.38905 13.6646C2.56655 13.8423 2.77733 13.9833 3.00935 14.0795C3.24136 14.1757 3.49006 14.2252 3.74123 14.2252C3.99239 14.2252 4.24109 14.1757 4.4731 14.0795C4.70512 13.9833 4.9159 13.8423 5.0934 13.6646L5.13122 13.6268C5.21066 13.5498 5.31121 13.4981 5.42011 13.4784C5.52984 13.4585 5.64302 13.4719 5.74504 13.517C5.7558 13.5217 5.76671 13.5261 5.77774 13.5302C5.88285 13.5688 5.9739 13.6382 6.03906 13.7293C6.10316 13.8189 6.13928 13.9255 6.14292 14.0356V14.0888C6.14292 14.5957 6.34428 15.0818 6.7027 15.4402C7.06112 15.7986 7.54724 16 8.05412 16C8.56101 16 9.04713 15.7986 9.40555 15.4402C9.76397 15.0818 9.96533 14.5957 9.96533 14.0888V13.9751C9.96593 13.8666 9.99817 13.7606 10.0581 13.6701C10.1182 13.5793 10.2035 13.5081 10.3036 13.4652L10.3036 13.4653L10.3091 13.4628C10.4111 13.4178 10.5243 13.4044 10.634 13.4243C10.7429 13.444 10.8434 13.4957 10.9229 13.5727L10.9607 13.6105C11.1382 13.7882 11.349 13.9292 11.581 14.0254C11.813 14.1215 12.0617 14.171 12.3129 14.171C12.5641 14.171 12.8128 14.1215 13.0448 14.0254C13.2767 13.9292 13.4874 13.7883 13.6649 13.6107C13.8424 13.4333 13.9833 13.2226 14.0795 12.9907C14.1757 12.7586 14.2252 12.5099 14.2252 12.2588C14.2252 12.0076 14.1757 11.7589 14.0795 11.5269C13.9833 11.2949 13.8423 11.0841 13.6646 10.9066L13.6268 10.8688C13.5498 10.7893 13.4981 10.6888 13.4784 10.5799C13.4585 10.4702 13.4719 10.357 13.517 10.255ZM13.6649 13.6107L13.6651 13.6105L13.2702 13.2161L13.6646 13.611L13.6649 13.6107ZM6.52854 8.00007C6.52854 7.18741 7.18734 6.52862 8 6.52862C8.81266 6.52862 9.47146 7.18741 9.47146 8.00007C9.47146 8.81274 8.81266 9.47153 8 9.47153C7.18734 9.47153 6.52854 8.81274 6.52854 8.00007ZM8 5.41234C6.57083 5.41234 5.41226 6.57091 5.41226 8.00007C5.41226 9.42924 6.57083 10.5878 8 10.5878C9.42917 10.5878 10.5877 9.42924 10.5877 8.00007C10.5877 6.57091 9.42917 5.41234 8 5.41234Z",
    fill: "currentColor"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "signout-old",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31111 1.37143C2.06189 1.37143 1.82288 1.47043 1.64666 1.64666C1.47043 1.82288 1.37143 2.06189 1.37143 2.31111V13.6889C1.37143 13.9381 1.47043 14.1771 1.64666 14.3533C1.82288 14.5296 2.06189 14.6286 2.31111 14.6286H5.5619C5.94061 14.6286 6.24762 14.9356 6.24762 15.3143C6.24762 15.693 5.94061 16 5.5619 16H2.31111C1.69817 16 1.11033 15.7565 0.676909 15.3231C0.243491 14.8897 0 14.3018 0 13.6889V2.31111C0 1.69817 0.243491 1.11033 0.676909 0.676909C1.11033 0.243491 1.69817 0 2.31111 0H5.5619C5.94061 0 6.24762 0.307005 6.24762 0.685714C6.24762 1.06442 5.94061 1.37143 5.5619 1.37143H2.31111ZM10.7659 3.45162C11.0337 3.18383 11.4679 3.18383 11.7357 3.45162L15.7992 7.51511C15.9247 7.64064 15.9914 7.80272 15.9992 7.96709C15.9997 7.97805 16 7.98903 16 8C16 8.09562 15.9804 8.18666 15.9451 8.26934C15.9155 8.33878 15.8738 8.40433 15.8203 8.46283C15.8126 8.47117 15.8048 8.47933 15.7967 8.48729L11.7357 12.5484C11.4679 12.8161 11.0337 12.8161 10.7659 12.5484C10.4981 12.2806 10.4981 11.8464 10.7659 11.5786L13.6588 8.68571H5.56191C5.1832 8.68571 4.87619 8.37871 4.87619 8C4.87619 7.62129 5.1832 7.31429 5.56191 7.31429H13.6588L10.7659 4.42137C10.4981 4.15358 10.4981 3.71941 10.7659 3.45162Z",
    fill: "currentColor"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "envelope-old",
    viewBox: "0 0 18 15",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1H15.4C16.28 1 17 1.73125 17 2.625V12.375C17 13.2688 16.28 14 15.4 14H2.6C1.72 14 1 13.2688 1 12.375V2.625C1 1.73125 1.72 1 2.6 1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2.62497L9 8.31247L1 2.62497",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "info-old",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.2V9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.8L9 5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "location-old",
    viewBox: "0 0 15 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7.54545C14 12.6364 7.5 17 7.5 17C7.5 17 1 12.6364 1 7.54545C1 5.80949 1.68482 4.14463 2.90381 2.91712C4.12279 1.68961 5.77609 1 7.5 1C9.22391 1 10.8772 1.68961 12.0962 2.91712C13.3152 4.14463 14 5.80949 14 7.54545Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4987 9.72728C8.69532 9.72728 9.66536 8.75045 9.66536 7.54547C9.66536 6.34048 8.69532 5.36365 7.4987 5.36365C6.30208 5.36365 5.33203 6.34048 5.33203 7.54547C5.33203 8.75045 6.30208 9.72728 7.4987 9.72728Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "crm-old",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.33331H17",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 17V6.33331",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "cart-old",
    viewBox: "0 0 24 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "dollar-old",
    viewBox: "0 0 14 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1V23",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5H4.5C3.57174 5 2.6815 5.36875 2.02513 6.02513C1.36875 6.6815 1 7.57174 1 8.5C1 9.42826 1.36875 10.3185 2.02513 10.9749C2.6815 11.6313 3.57174 12 4.5 12H9.5C10.4283 12 11.3185 12.3687 11.9749 13.0251C12.6313 13.6815 13 14.5717 13 15.5C13 16.4283 12.6313 17.3185 11.9749 17.9749C11.3185 18.6313 10.4283 19 9.5 19H1",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "book-old",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H7C8.06087 1 9.07828 1.42143 9.82843 2.17157C10.5786 2.92172 11 3.93913 11 5V19C11 18.2044 10.6839 17.4413 10.1213 16.8787C9.55871 16.3161 8.79565 16 8 16H1V1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 1H15C13.9391 1 12.9217 1.42143 12.1716 2.17157C11.4214 2.92172 11 3.93913 11 5V19C11 18.2044 11.3161 17.4413 11.8787 16.8787C12.4413 16.3161 13.2044 16 14 16H21V1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "burger-old",
    viewBox: "0 0 24 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 24,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 14,
    height: 3,
    fill: "currentColor"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "show",
    viewBox: "0 0 58 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.2 28.8l25.6-25.6 25.6 25.6"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.2857,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.714 2.286l-27.428 27.429M2.286 2.286l27.428 27.429"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-today",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.667 4h-1.333v-2.667h-2.667v2.667h-13.333v-2.667h-2.667v2.667h-1.333c-1.467 0-2.667 1.2-2.667 2.667v21.333c0 1.467 1.2 2.667 2.667 2.667h21.333c1.467 0 2.667-1.2 2.667-2.667v-21.333c0-1.467-1.2-2.667-2.667-2.667zM26.667 28h-21.333v-14.667h21.333v14.667zM26.667 10.667h-21.333v-4h21.333v4z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4101 13.6933L8.3678 11.651C8.14375 11.4269 7.86704 11.3149 7.53767 11.3149C7.2083 11.3149 6.91627 11.4356 6.66157 11.6769C6.43752 11.9181 6.3255 12.2025 6.3255 12.53C6.3255 12.8574 6.44614 13.1332 6.68743 13.3572L9.53114 16.2268C9.78027 16.4681 10.0709 16.5887 10.403 16.5887C10.7352 16.5887 11.0306 16.4681 11.2891 16.2268L17.1575 10.3326C17.416 10.0913 17.5452 9.81025 17.5452 9.48949C17.5452 9.16874 17.416 8.88102 17.1575 8.62632C16.9162 8.40227 16.6265 8.29456 16.2886 8.30317C15.9506 8.31179 15.6628 8.42812 15.4254 8.65217L10.4101 13.6933ZM11.9906 23C10.4716 23 9.04437 22.7149 7.70891 22.1447C6.37344 21.5745 5.20651 20.7903 4.20812 19.7919C3.20974 18.7935 2.42546 17.6278 1.85529 16.2947C1.2851 14.9616 1 13.5355 1 12.0165C1 10.4802 1.2851 9.04437 1.85529 7.70891C2.42546 6.37344 3.20838 5.21037 4.20406 4.2197C5.19974 3.22902 6.36476 2.44474 7.69912 1.86684C9.03347 1.28895 10.4609 1 11.9814 1C13.5191 1 14.9567 1.28828 16.2942 1.86485C17.6317 2.4414 18.7951 3.22387 19.7845 4.21226C20.7739 5.20065 21.5571 6.36292 22.1343 7.69909C22.7114 9.03524 23 10.4732 23 12.0129C23 13.5343 22.7111 14.9626 22.1332 16.2978C21.5553 17.633 20.771 18.7987 19.7803 19.795C18.7896 20.7913 17.6278 21.5745 16.2947 22.1447C14.9616 22.7149 13.5269 23 11.9906 23Z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "info",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1.333c-8.096 0-14.667 6.571-14.667 14.667s6.571 14.667 14.667 14.667c8.096 0 14.667-6.571 14.667-14.667s-6.571-14.667-14.667-14.667zM17.467 23.333h-2.933v-8.8h2.933v8.8zM17.467 11.6h-2.933v-2.933h2.933v2.933z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 29.151h32l-16-27.636-16 27.636zM17.455 24.788h-2.909v-2.909h2.909v2.909zM17.455 18.97h-2.909v-5.818h2.909v5.818z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 8.456l-2.456-2.456-7.544 7.544-7.544-7.544-2.456 2.456 7.544 7.544-7.544 7.544 2.456 2.456 7.544-7.544 7.544 7.544 2.456-2.456-7.544-7.544 7.544-7.544z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.298 19.782h-1.325l-0.47-0.453c1.644-1.912 2.633-4.394 2.633-7.094 0-6.021-4.881-10.901-10.901-10.901s-10.901 4.88-10.901 10.901c0 6.021 4.88 10.901 10.901 10.901 2.7 0 5.182-0.989 7.094-2.633l0.453 0.47v1.325l8.386 8.369 2.499-2.499-8.369-8.386zM12.235 19.782c-4.176 0-7.547-3.371-7.547-7.547s3.371-7.547 7.547-7.547c4.176 0 7.547 3.371 7.547 7.547s-3.371 7.547-7.547 7.547z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "more-Horiz",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5c-1.833 0-3.333 1.5-3.333 3.333s1.5 3.333 3.333 3.333c1.833 0 3.333-1.5 3.333-3.333s-1.5-3.333-3.333-3.333zM26 12.5c-1.833 0-3.333 1.5-3.333 3.333s1.5 3.333 3.333 3.333c1.833 0 3.333-1.5 3.333-3.333s-1.5-3.333-3.333-3.333zM16 12.5c-1.833 0-3.333 1.5-3.333 3.333s1.5 3.333 3.333 3.333c1.833 0 3.333-1.5 3.333-3.333s-1.5-3.333-3.333-3.333z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.045 2.667l-3.045 3.133 9.889 10.2-9.889 10.2 3.045 3.133 12.955-13.333-12.955-13.333z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.955 2.667l3.045 3.133-9.889 10.2 9.889 10.2-3.045 3.133-12.955-13.333 12.955-13.333z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "tune",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.667 23.407v2.963h8.889v-2.963h-8.889zM2.667 5.63v2.963h14.815v-2.963h-14.815zM17.481 29.333v-2.963h11.852v-2.963h-11.852v-2.963h-2.963v8.889h2.963zM8.593 11.556v2.963h-5.926v2.963h5.926v2.963h2.963v-8.889h-2.963zM29.333 17.481v-2.963h-14.815v2.963h14.815zM20.444 11.556h2.963v-2.963h5.926v-2.963h-5.926v-2.963h-2.963v8.889z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "add",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 22C11.6846 22 11.4207 21.8935 11.208 21.6806C10.9953 21.4676 10.8889 21.2037 10.8889 20.8889V13.1111H3.11108C2.79626 13.1111 2.53238 13.0046 2.31945 12.7915C2.10648 12.5785 2 12.3145 2 11.9995C2 11.6846 2.10648 11.4207 2.31945 11.208C2.53238 10.9953 2.79626 10.8889 3.11108 10.8889H10.8889V3.11108C10.8889 2.79626 10.9954 2.53237 11.2085 2.31941C11.4215 2.10647 11.6855 2 12.0005 2C12.3154 2 12.5793 2.10647 12.792 2.31941C13.0047 2.53237 13.1111 2.79626 13.1111 3.11108V10.8889H20.8889C21.2037 10.8889 21.4676 10.9954 21.6806 11.2085C21.8935 11.4215 22 11.6855 22 12.0005C22 12.3154 21.8935 12.5793 21.6806 12.792C21.4676 13.0047 21.2037 13.1111 20.8889 13.1111H13.1111V20.8889C13.1111 21.2037 13.0046 21.4676 12.7915 21.6806C12.5785 21.8935 12.3145 22 11.9995 22Z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "mop",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.687 12.269l1.866 1.866 4.787-4.787c0.244-0.244 0.367-0.55 0.37-0.92s-0.123-0.682-0.378-0.938c-0.255-0.255-0.566-0.383-0.933-0.383s-0.675 0.125-0.925 0.375l-4.787 4.787zM10.576 11.469l10.776 10.776 1.847-1.847-10.776-10.776-1.847 1.847zM4.769 15.030l1.98 1.98 1.18-1.181c0.251-0.251 0.549-0.376 0.896-0.375s0.646 0.127 0.897 0.378c0.252 0.252 0.377 0.55 0.375 0.894s-0.128 0.642-0.378 0.892l-1.18 1.181 1.847 1.847 1.18-1.18c0.251-0.251 0.549-0.376 0.896-0.375s0.646 0.127 0.897 0.379c0.252 0.252 0.377 0.55 0.375 0.894s-0.128 0.642-0.378 0.893l-1.18 1.18 1.847 1.847 1.18-1.18c0.251-0.251 0.549-0.376 0.896-0.375s0.646 0.127 0.897 0.378c0.252 0.252 0.377 0.55 0.375 0.894s-0.128 0.642-0.378 0.893l-1.18 1.18 1.98 1.98 2.651-4.317-11.333-11.333-4.341 2.627zM15.926 29.766l-12.871-12.871c-0.609-0.609-0.857-1.331-0.745-2.167s0.544-1.478 1.298-1.927l5.312-3.256 1.656-1.656c0.52-0.52 1.14-0.781 1.86-0.785s1.338 0.252 1.852 0.766l2.608 2.608 4.779-4.779c0.748-0.748 1.655-1.122 2.723-1.121s1.975 0.374 2.723 1.123 1.122 1.656 1.121 2.722c-0.001 1.067-0.375 1.974-1.123 2.722l-4.779 4.779 2.608 2.609c0.514 0.514 0.77 1.132 0.766 1.852s-0.265 1.341-0.785 1.86l-1.656 1.656-3.237 5.293c-0.48 0.733-1.137 1.16-1.971 1.28s-1.548-0.116-2.141-0.709z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "north",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.778 32v-25.191l6.382 6.364 2.507-2.507-10.667-10.667-10.667 10.667 2.507 2.507 6.382-6.364v25.191h3.555z"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "south",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.222 0v25.191l-6.382-6.364-2.507 2.507 10.667 10.667 10.667-10.667-2.507-2.507-6.382 6.364v-25.191h-3.555z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "sort-desc",
    viewBox: "0 0 3 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    style: {
      fill: "var(--color1, #374151)"
    },
    d: "M1.667 4.375l1.083-1.406h-2.165l1.083 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    style: {
      fill: "var(--color2, #9ca3af)"
    },
    d: "M1.667 0.625l-1.083 1.406h2.165l-1.083-1.406z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sort-asc",
    viewBox: "0 0 3 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    style: {
      fill: "var(--color1, #9ca3af)"
    },
    d: "M1.667 4.375l1.083-1.406h-2.165l1.083 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    style: {
      fill: "var(--color2, #374151)"
    },
    d: "M1.667 0.625l-1.083 1.406h2.165l-1.083-1.406z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sort-unsorted",
    viewBox: "0 0 3 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    style: {
      fill: "var(--color1, #9ca3af)"
    },
    d: "M1.667 4.375l1.083-1.406h-2.165l1.083 1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    style: {
      fill: "var(--color2, #9ca3af)"
    },
    d: "M1.667 0.625l-1.083 1.406h2.165l-1.083-1.406z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "note",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    style: {
      fill: "var(--color1, currentColor)"
    },
    d: "M4.559 0h-4.118c-0.243 0-0.441 0.197-0.441 0.439v2.924c0 0.242 0.198 0.439 0.441 0.439h0.147v1.199l1.379-1.199h2.592c0.243 0 0.441-0.197 0.441-0.439v-2.924c0-0.242-0.198-0.439-0.441-0.439zM4.706 3.362c0 0.080-0.066 0.146-0.147 0.146h-2.702l-0.974 0.847v-0.847h-0.441c-0.081 0-0.147-0.066-0.147-0.146v-2.924c0-0.080 0.066-0.146 0.147-0.146h4.118c0.081 0 0.147 0.066 0.147 0.146v2.924zM0.882 0.877h3.235v0.292h-3.235v-0.292zM0.882 1.462h3.235v0.292h-3.235v-0.292zM0.882 2.047h1.765v0.292h-1.765v-0.292z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "plus-button",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.3125,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    style: {
      stroke: "var(--color1, #dcdcdc)"
    },
    d: "M0.625 0.156h3.75c0.259 0 0.469 0.21 0.469 0.469v3.75c0 0.259-0.21 0.469-0.469 0.469h-3.75c-0.259 0-0.469-0.21-0.469-0.469v-3.75c0-0.259 0.21-0.469 0.469-0.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.3125,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #4f4f4f)"
    },
    d: "M2.5 3.625v-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.3125,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #4f4f4f)"
    },
    d: "M1.375 2.5h2.25"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cross-button",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    style: {
      fill: "var(--color1, #f5f5f5)"
    },
    d: "M2.5 0c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.3406,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #747474)"
    },
    d: "M3.75 1.25l-2.5 2.5M1.25 1.25l2.5 2.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.303,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color1, currentColor)"
    },
    d: "M4.722 3.241v0.988c0 0.131-0.052 0.257-0.145 0.349s-0.218 0.145-0.349 0.145h-3.457c-0.131 0-0.257-0.052-0.349-0.145s-0.145-0.218-0.145-0.349v-0.988"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.303,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color1, currentColor)"
    },
    d: "M1.265 2.006l1.235 1.235 1.235-1.235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.303,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color1, currentColor)"
    },
    d: "M2.5 3.241v-2.963"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mailru",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#168de2",
    style: {
      fill: "var(--color1, #168de2)"
    },
    d: "M0.625 0h3.75c0.345 0 0.625 0.28 0.625 0.625v3.75c0 0.345-0.28 0.625-0.625 0.625h-3.75c-0.345 0-0.625-0.28-0.625-0.625v-3.75c0-0.345 0.28-0.625 0.625-0.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M3.175 2.482c-0.022-0.432-0.343-0.691-0.73-0.691h-0.015c-0.447 0-0.695 0.351-0.695 0.75 0 0.447 0.3 0.729 0.693 0.729 0.438 0 0.726-0.321 0.747-0.701l-0.001-0.087zM2.432 1.404c0.299 0 0.579 0.132 0.785 0.339v0.001c0-0.099 0.067-0.174 0.159-0.174l0.023-0c0.145 0 0.175 0.137 0.175 0.181l0.001 1.542c-0.010 0.101 0.104 0.153 0.168 0.088 0.248-0.254 0.544-1.308-0.154-1.919-0.65-0.569-1.523-0.475-1.987-0.156-0.493 0.34-0.809 1.093-0.502 1.801 0.334 0.771 1.291 1.002 1.859 0.772 0.288-0.116 0.421 0.273 0.122 0.4-0.452 0.192-1.709 0.173-2.297-0.845-0.397-0.687-0.376-1.896 0.677-2.522 0.805-0.479 1.867-0.347 2.507 0.322 0.669 0.699 0.63 2.008-0.023 2.516-0.296 0.231-0.735 0.006-0.732-0.331l-0.003-0.11c-0.206 0.204-0.48 0.324-0.778 0.324-0.59 0-1.109-0.519-1.109-1.109 0-0.596 0.519-1.121 1.109-1.121v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "fb",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    style: {
      fill: "var(--color3, #1877f2)"
    },
    d: "M3.655 2.791l0.138-0.898h-0.862v-0.583c0-0.246 0.12-0.485 0.506-0.485h0.392v-0.765c0 0-0.356-0.061-0.695-0.061-0.71 0-1.173 0.43-1.173 1.209v0.684h-0.789v0.898h0.789v2.171c0.158 0.025 0.32 0.038 0.485 0.038s0.327-0.013 0.485-0.038v-2.171h0.724z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "google_ads",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc04",
    style: {
      fill: "var(--color4, #fbbc04)"
    },
    d: "M0.115 3.625l1.66-3.17c0.211 0.138 1.274 0.795 1.446 0.92l-1.66 3.17c-0.181 0.267-1.676-0.514-1.446-0.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    style: {
      fill: "var(--color5, #4285f4)"
    },
    d: "M4.889 3.625l-1.66-3.17c-0.232-0.431-0.732-0.587-1.142-0.333s-0.536 0.802-0.303 1.252l1.66 3.17c0.232 0.431 0.732 0.587 1.142 0.333 0.393-0.254 0.536-0.822 0.303-1.252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    style: {
      fill: "var(--color6, #34a853)"
    },
    d: "M0.833 5c0.46 0 0.833-0.406 0.833-0.906s-0.373-0.906-0.833-0.906-0.833 0.406-0.833 0.906c0 0.501 0.373 0.906 0.833 0.906z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "snapchat",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fffc40",
    style: {
      fill: "var(--color7, #fffc40)"
    },
    d: "M0.875 0h3.25c0.483 0 0.875 0.392 0.875 0.875v3.25c0 0.483-0.392 0.875-0.875 0.875h-3.25c-0.483 0-0.875-0.392-0.875-0.875v-3.25c0-0.483 0.392-0.875 0.875-0.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M2.5 4.219c0.37 0 0.463-0.234 0.682-0.313 0.164-0.059 0.398-0.030 0.505-0.011 0.003 0.001 0.007 0.001 0.011 0.001 0.030 0 0.055-0.021 0.060-0.049l0-0 0.034-0.149c0.007-0.027 0.030-0.047 0.058-0.048l0-0c0.379-0.018 0.445-0.126 0.449-0.19 0-0 0-0.001 0-0.001 0-0.027-0.017-0.050-0.041-0.059l-0-0c-0.838-0.304-0.796-0.663-0.714-0.832 0.029-0.056 0.083-0.096 0.147-0.105l0.001-0c0.329-0.051 0.292-0.402 0.095-0.296-0.214 0.115-0.328 0.031-0.328 0.031v-0.505c0-0.537-0.429-0.912-0.959-0.912v0c-0.53 0-0.959 0.372-0.959 0.909v0.507s-0.114 0.084-0.328-0.031c-0.198-0.106-0.234 0.245 0.095 0.296 0.065 0.009 0.119 0.048 0.148 0.104l0.001 0.001c0.082 0.17 0.124 0.528-0.714 0.832-0.024 0.009-0.041 0.032-0.041 0.059 0 0 0 0.001 0 0.001v-0c0.005 0.064 0.070 0.172 0.449 0.19 0.028 0.001 0.052 0.021 0.059 0.048l0 0 0.034 0.149c0.006 0.028 0.031 0.049 0.060 0.049 0.004 0 0.007-0 0.011-0.001l-0 0c0.107-0.019 0.341-0.048 0.505 0.011 0.219 0.079 0.313 0.313 0.682 0.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    style: {
      fill: "var(--color8, #231f20)"
    },
    d: "M2.5 4.263c-0.001 0-0.003 0-0.004 0-0.193 0-0.368-0.073-0.501-0.192l0.001 0.001c-0.055-0.048-0.119-0.087-0.189-0.116l-0.005-0.002c-0.156-0.056-0.391-0.025-0.48-0.009-0.006 0.001-0.012 0.002-0.018 0.002-0.052 0-0.095-0.036-0.107-0.084l-0-0.001-0.034-0.149c-0.001-0.007-0.008-0.012-0.015-0.012h-0c-0.395-0.019-0.487-0.137-0.494-0.234-0-0.001-0-0.002-0-0.003 0-0.047 0.030-0.087 0.072-0.102l0.001-0c0.384-0.139 0.625-0.313 0.703-0.491 0.015-0.037 0.024-0.080 0.024-0.125 0-0.055-0.013-0.107-0.037-0.153l0.001 0.002c-0.022-0.042-0.064-0.072-0.113-0.078l-0.001-0c-0.129-0.010-0.236-0.095-0.277-0.212l-0.001-0.002c-0.006-0.016-0.009-0.034-0.009-0.052 0-0.047 0.020-0.088 0.053-0.117l0-0c0.024-0.016 0.053-0.026 0.085-0.026s0.061 0.010 0.085 0.026l-0.001-0c0.049 0.034 0.11 0.054 0.176 0.054 0.029 0 0.058-0.004 0.085-0.012l-0.002 0.001v-0.48c0-0.547 0.432-0.955 1.005-0.955s1.005 0.41 1.005 0.955v0.479c0.024 0.007 0.052 0.011 0.081 0.011 0.066 0 0.128-0.020 0.179-0.055l-0.001 0.001c0.024-0.016 0.053-0.026 0.085-0.026s0.061 0.010 0.085 0.026l-0.001-0c0.032 0.029 0.053 0.071 0.053 0.117 0 0.019-0.003 0.037-0.009 0.054l0-0.001c-0.042 0.119-0.149 0.205-0.277 0.214l-0.001 0c-0.049 0.006-0.091 0.036-0.113 0.077l-0 0.001c-0.023 0.044-0.036 0.096-0.036 0.151 0 0.045 0.009 0.088 0.025 0.128l-0.001-0.002c0.078 0.182 0.313 0.352 0.703 0.491 0.043 0.015 0.073 0.055 0.073 0.102 0 0.002-0 0.004-0 0.005l0-0c-0.007 0.096-0.098 0.215-0.494 0.234-0.007 0-0.013 0.005-0.015 0.012l-0 0-0.034 0.149c-0.011 0.049-0.055 0.085-0.107 0.085-0.006 0-0.013-0.001-0.019-0.002l0.001 0c-0.092-0.016-0.325-0.047-0.48 0.009-0.074 0.031-0.138 0.070-0.195 0.119l0.001-0.001c-0.132 0.118-0.307 0.191-0.499 0.191-0.005 0-0.009-0-0.014-0l0.001 0zM1.574 3.828c0.005-0 0.010-0 0.016-0 0.087 0 0.171 0.014 0.249 0.040l-0.006-0.002c0.084 0.035 0.156 0.079 0.22 0.132l-0.001-0.001c0.118 0.107 0.275 0.173 0.448 0.173s0.33-0.066 0.448-0.173l-0.001 0c0.063-0.052 0.135-0.097 0.213-0.129l0.006-0.002c0.088-0.024 0.188-0.038 0.292-0.038 0.084 0 0.165 0.009 0.243 0.026l-0.008-0.001c0.001 0 0.002 0 0.003 0 0.008 0 0.014-0.005 0.015-0.013l0-0 0.038-0.151c0.011-0.048 0.052-0.083 0.102-0.085l0-0c0.366-0.017 0.402-0.116 0.404-0.147 0 0 0-0.009-0.011-0.012-0.415-0.151-0.669-0.334-0.754-0.547-0.020-0.048-0.032-0.103-0.032-0.161 0-0.070 0.017-0.136 0.047-0.194l-0.001 0.002c0.037-0.066 0.102-0.113 0.178-0.124l0.001-0c0.092-0.004 0.17-0.062 0.201-0.144l0.001-0.002c0.003-0.008 0.005-0.016 0.005-0.026 0-0.017-0.006-0.033-0.017-0.046l0 0c-0.013-0.011-0.037-0.008-0.066 0.008-0.234 0.127-0.372 0.032-0.378 0.028l-0.019-0.014v-0.531c0-0.491-0.391-0.859-0.912-0.859s-0.912 0.37-0.912 0.859v0.531l-0.019 0.014c-0.006 0.004-0.141 0.099-0.378-0.028-0.029-0.016-0.053-0.019-0.066-0.008-0.010 0.012-0.016 0.028-0.016 0.046 0 0.009 0.002 0.018 0.005 0.026l-0-0c0.032 0.083 0.109 0.142 0.201 0.145l0 0c0.081 0.011 0.148 0.061 0.183 0.129l0.001 0.001c0.029 0.056 0.046 0.122 0.046 0.192 0 0.058-0.012 0.114-0.033 0.164l0.001-0.003c-0.085 0.21-0.339 0.391-0.754 0.547-0.007 0-0.012 0.008-0.011 0.012 0 0.030 0.037 0.13 0.404 0.147 0.050 0.002 0.091 0.037 0.102 0.084l0 0.001 0.034 0.149c0.001 0.007 0.008 0.013 0.015 0.013 0.001 0 0.002-0 0.003-0l-0 0c0.080-0.016 0.172-0.027 0.267-0.030l0.002-0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#55acee",
    style: {
      fill: "var(--color9, #55acee)"
    },
    d: "M4.999 0.95c-0.184 0.082-0.381 0.137-0.589 0.161 0.212-0.127 0.374-0.328 0.451-0.567-0.198 0.117-0.418 0.203-0.651 0.249-0.187-0.199-0.454-0.324-0.749-0.324-0.566 0-1.025 0.459-1.025 1.025 0 0.080 0.009 0.159 0.026 0.234-0.852-0.043-1.608-0.451-2.114-1.072-0.088 0.152-0.139 0.328-0.139 0.516 0 0.356 0.181 0.67 0.456 0.854-0.168-0.005-0.326-0.051-0.464-0.128-0 0.004-0 0.009-0 0.013 0 0.497 0.353 0.912 0.823 1.006-0.086 0.023-0.177 0.036-0.27 0.036-0.066 0-0.13-0.006-0.193-0.018 0.13 0.407 0.509 0.704 0.958 0.712-0.351 0.275-0.793 0.439-1.273 0.439-0.083 0-0.165-0.005-0.245-0.014 0.454 0.291 0.993 0.46 1.572 0.46 1.886 0 2.918-1.563 2.918-2.918 0-0.044-0.001-0.089-0.003-0.133 0.2-0.145 0.374-0.325 0.512-0.531z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "vk",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5181b8",
    style: {
      fill: "var(--color10, #5181b8)"
    },
    d: "M0.313 1.086c0.164 0 0.414 0 0.555 0 0.070 0 0.125 0.047 0.148 0.109 0.070 0.203 0.227 0.648 0.406 0.953 0.242 0.398 0.398 0.547 0.5 0.531 0.102-0.023 0.070-0.289 0.070-0.5s0.023-0.57-0.078-0.734l-0.156-0.227c-0.039-0.055 0-0.125 0.063-0.125h0.891c0.086 0 0.156 0.070 0.156 0.156v1.133c0 0 0.039 0.203 0.258-0.008s0.453-0.602 0.648-1l0.078-0.188c0.023-0.055 0.078-0.094 0.141-0.094h0.578c0.109 0 0.188 0.109 0.148 0.211l-0.062 0.164c0 0-0.211 0.422-0.43 0.719-0.219 0.305-0.266 0.375-0.234 0.453s0.594 0.602 0.734 0.852c0.039 0.070 0.070 0.133 0.102 0.188 0.055 0.102-0.023 0.234-0.141 0.234h-0.656c-0.055 0-0.109-0.031-0.133-0.078l-0.062-0.102c0 0-0.398-0.469-0.641-0.617-0.25-0.141-0.242 0.062-0.242 0.062v0.414c0 0.172-0.141 0.313-0.313 0.313h-0.156c0 0-0.859 0-1.547-1.023-0.539-0.797-0.719-1.312-0.781-1.609-0.016-0.094 0.055-0.188 0.156-0.188z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "yandex",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e7322b",
    style: {
      fill: "var(--color11, #e7322b)"
    },
    d: "M0.625 0h3.75c0.345 0 0.625 0.28 0.625 0.625v3.75c0 0.345-0.28 0.625-0.625 0.625h-3.75c-0.345 0-0.625-0.28-0.625-0.625v-3.75c0-0.345 0.28-0.625 0.625-0.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M3.375 0.547h-0.592c-0.582 0-1.075 0.443-1.075 1.302 0 0.516 0.239 0.896 0.665 1.083l-0.794 1.438c-0.026 0.047 0 0.083 0.041 0.083h0.369c0.031 0 0.052-0.010 0.062-0.036l0.722-1.412h0.26v1.412c0 0.016 0.016 0.036 0.036 0.036h0.322c0.031 0 0.042-0.016 0.042-0.042v-3.813c0-0.037-0.021-0.052-0.057-0.052zM3.032 2.672h-0.218c-0.343 0-0.675-0.25-0.675-0.875 0-0.651 0.311-0.917 0.628-0.917h0.265v1.792z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "linkedin",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007bb5",
    style: {
      fill: "var(--color1, #007bb5)"
    },
    d: "M0 1.406h1.094v3.594h-1.094v-3.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007bb5",
    style: {
      fill: "var(--color1, #007bb5)"
    },
    d: "M3.75 1.406c-0.625 0-0.799 0.205-0.938 0.469v-0.469h-1.094v3.594h1.094v-2.031c0-0.313 0-0.625 0.547-0.625s0.547 0.313 0.547 0.625v2.031h1.094v-2.031c0-0.938-0.156-1.563-1.25-1.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007bb5",
    style: {
      fill: "var(--color1, #007bb5)"
    },
    d: "M1.094 0.547c0 0.302-0.245 0.547-0.547 0.547s-0.547-0.245-0.547-0.547c0-0.302 0.245-0.547 0.547-0.547s0.547 0.245 0.547 0.547z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "telegram",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#20a0e1",
    style: {
      fill: "var(--color2, #20a0e1)"
    },
    d: "M4.733 0.959l-0.678 3.197c-0.051 0.226-0.185 0.282-0.374 0.176l-1.033-0.761-0.498 0.479c-0.055 0.055-0.101 0.101-0.208 0.101l0.074-1.052 1.914-1.73c0.083-0.074-0.018-0.115-0.129-0.041l-2.367 1.49-1.019-0.319c-0.222-0.069-0.226-0.222 0.046-0.328l3.985-1.535c0.185-0.069 0.346 0.041 0.286 0.323z"
  })), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "tiktok",
    viewBox: "0 0 4 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 2.050c-0.001 0-0.003 0-0.005 0-0.448 0-0.863-0.144-1.2-0.387l0.006 0.004v1.745c-0 0.876-0.711 1.587-1.587 1.587s-1.587-0.711-1.587-1.587 0.711-1.587 1.587-1.587c0.077 0 0.152 0.005 0.226 0.016l-0.008-0.001v0.878c-0.065-0.021-0.141-0.034-0.219-0.034-0.402 0-0.729 0.326-0.729 0.729s0.326 0.729 0.729 0.729c0.402 0 0.729-0.326 0.729-0.729 0-0 0-0 0-0v0-3.412h0.859c-0 0.003-0 0.006-0 0.010 0 0.073 0.007 0.145 0.019 0.214l-0.001-0.007c0.063 0.331 0.256 0.607 0.522 0.781l0.005 0.003c0.184 0.123 0.41 0.197 0.654 0.197 0 0 0 0 0 0h-0z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "mailbox",
    viewBox: "0 0 18 15",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1H15.4C16.28 1 17 1.73125 17 2.625V12.375C17 13.2688 16.28 14 15.4 14H2.6C1.72 14 1 13.2688 1 12.375V2.625C1 1.73125 1.72 1 2.6 1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2.62497L9 8.31247L1 2.62497",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "support",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.2V9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.8L9 5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "clients",
    viewBox: "0 0 15 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7.54545C14 12.6364 7.5 17 7.5 17C7.5 17 1 12.6364 1 7.54545C1 5.80949 1.68482 4.14463 2.90381 2.91712C4.12279 1.68961 5.77609 1 7.5 1C9.22391 1 10.8772 1.68961 12.0962 2.91712C13.3152 4.14463 14 5.80949 14 7.54545Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4987 9.72728C8.69532 9.72728 9.66536 8.75045 9.66536 7.54547C9.66536 6.34048 8.69532 5.36365 7.4987 5.36365C6.30208 5.36365 5.33203 6.34048 5.33203 7.54547C5.33203 8.75045 6.30208 9.72728 7.4987 9.72728Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "crm",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.33331H17",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 17V6.33331",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "sales",
    viewBox: "0 0 24 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "finances",
    viewBox: "0 0 14 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1V23",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5H4.5C3.57174 5 2.6815 5.36875 2.02513 6.02513C1.36875 6.6815 1 7.57174 1 8.5C1 9.42826 1.36875 10.3185 2.02513 10.9749C2.6815 11.6313 3.57174 12 4.5 12H9.5C10.4283 12 11.3185 12.3687 11.9749 13.0251C12.6313 13.6815 13 14.5717 13 15.5C13 16.4283 12.6313 17.3185 11.9749 17.9749C11.3185 18.6313 10.4283 19 9.5 19H1",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "academy",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H7C8.06087 1 9.07828 1.42143 9.82843 2.17157C10.5786 2.92172 11 3.93913 11 5V19C11 18.2044 10.6839 17.4413 10.1213 16.8787C9.55871 16.3161 8.79565 16 8 16H1V1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 1H15C13.9391 1 12.9217 1.42143 12.1716 2.17157C11.4214 2.92172 11 3.93913 11 5V19C11 18.2044 11.3161 17.4413 11.8787 16.8787C12.4413 16.3161 13.2044 16 14 16H21V1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "protext",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7L11 1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1V7H17",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12H5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16H5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8H6H5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "seo",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21L6.5 13.75",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21L11.9999 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21L1 16.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 2.25L1 10.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90906 1H12V4.85025",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "dev",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 21C9 21 17 17 17 11V4L9 1L1 4V11C1 17 9 21 9 21Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "context",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6654 5.8C13.954 5.8 14.9987 4.72548 14.9987 3.4C14.9987 2.07452 13.954 1 12.6654 1C11.3767 1 10.332 2.07452 10.332 3.4C10.332 4.72548 11.3767 5.8 12.6654 5.8Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 11.4C4.622 11.4 5.66667 10.3255 5.66667 8.99998C5.66667 7.67449 4.622 6.59998 3.33333 6.59998C2.04467 6.59998 1 7.67449 1 8.99998C1 10.3255 2.04467 11.4 3.33333 11.4Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6654 17C13.954 17 14.9987 15.9254 14.9987 14.6C14.9987 13.2745 13.954 12.2 12.6654 12.2C11.3767 12.2 10.332 13.2745 10.332 14.6C10.332 15.9254 11.3767 17 12.6654 17Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34766 10.208L10.6599 13.392",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6521 4.60803L5.34766 7.79203",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "communication",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9381 5C14.9149 5.19057 15.8125 5.66826 16.5162 6.37194C17.2199 7.07561 17.6976 7.97326 17.8881 8.95M13.9381 1C15.9674 1.22544 17.8597 2.13417 19.3044 3.57701C20.749 5.01984 21.6601 6.91101 21.8881 8.94M20.8881 16.92V19.92C20.8892 20.1985 20.8322 20.4742 20.7206 20.7293C20.6091 20.9845 20.4454 21.2136 20.2402 21.4019C20.035 21.5901 19.7927 21.7335 19.5289 21.8227C19.265 21.9119 18.9855 21.9451 18.7081 21.92C15.631 21.5856 12.6751 20.5341 10.0781 18.85C7.66194 17.3147 5.61345 15.2662 4.07812 12.85C2.38809 10.2412 1.33636 7.27099 1.00812 4.18C0.983127 3.90347 1.01599 3.62476 1.10462 3.36162C1.19324 3.09849 1.33569 2.85669 1.52288 2.65162C1.71008 2.44655 1.93792 2.28271 2.19191 2.17052C2.44589 2.05833 2.72046 2.00026 2.99812 2H5.99812C6.48342 1.99522 6.95391 2.16708 7.32188 2.48353C7.68985 2.79999 7.93019 3.23945 7.99812 3.72C8.12474 4.68007 8.35957 5.62273 8.69812 6.53C8.83266 6.88792 8.86178 7.27691 8.78202 7.65088C8.70227 8.02485 8.51698 8.36811 8.24812 8.64L6.97812 9.91C8.40167 12.4135 10.4746 14.4864 12.9781 15.91L14.2481 14.64C14.52 14.3711 14.8633 14.1858 15.2372 14.1061C15.6112 14.0263 16.0002 14.0555 16.3581 14.19C17.2654 14.5286 18.2081 14.7634 19.1681 14.89C19.6539 14.9585 20.0975 15.2032 20.4146 15.5775C20.7318 15.9518 20.9003 16.4296 20.8881 16.92Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "marketing",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H8L10 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V17Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "password",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4444 8.20221H2.55556C1.69645 8.20221 1 8.91837 1 9.80181V15.4004C1 16.2838 1.69645 17 2.55556 17H13.4444C14.3036 17 15 16.2838 15 15.4004V9.80181C15 8.91837 14.3036 8.20221 13.4444 8.20221Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 8.20222V5.00302C4.10841 4.01131 4.46582 3.0546 5.11222 2.31863C5.75863 1.58266 6.64791 1.11992 7.60744 1.02026C8.56696 0.920589 9.52827 1.1911 10.3047 1.77928C11.0812 2.36746 11.6175 3.23134 11.8094 4.20322",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4444 2.59998H2.55556C1.69645 2.59998 1 3.31632 1 4.19998V15.4C1 16.2836 1.69645 17 2.55556 17H13.4444C14.3036 17 15 16.2836 15 15.4V4.19998C15 3.31632 14.3036 2.59998 13.4444 2.59998Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1133 1V4.2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89062 1V4.2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7.40002H15",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "task",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05469 8.11114L8.581 10.7778L17.0021 1.88892",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1579 9V15.2222C16.1579 15.6937 15.9805 16.1459 15.6646 16.4793C15.3487 16.8127 14.9204 17 14.4737 17H2.68421C2.23753 17 1.80914 16.8127 1.49329 16.4793C1.17744 16.1459 1 15.6937 1 15.2222V2.77778C1 2.30628 1.17744 1.8541 1.49329 1.5207C1.80914 1.1873 2.23753 1 2.68421 1H11.9474",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "staff",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1H19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7H19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13H19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H1.01",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7H1.01",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13H1.01",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "tools",
    viewBox: "0 0 22 28",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 1L13.5 10.5L8.5 5.5L1 13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 1H23V7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "roombook",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 13C19 13.5304 18.7893 14.0391 18.4142 14.4142C18.0391 14.7893 17.5304 15 17 15H5L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V13Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "report",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V8L10 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1V8H17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "postoffice",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H8L10 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V17Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "documents",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V8L10 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1V8H17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "commission",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V8L10 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1V8H17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "two-person",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1904 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16667C3.28261 12.5 2.43477 12.8512 1.80965 13.4763C1.18453 14.1014 0.833336 14.9493 0.833336 15.8333V17.5",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16667C9.34095 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34095 2.5 7.5 2.5C5.65905 2.5 4.16666 3.99238 4.16666 5.83333C4.16666 7.67428 5.65905 9.16667 7.5 9.16667Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 17.5V15.8333C19.1661 15.0948 18.9203 14.3773 18.4678 13.7936C18.0153 13.2099 17.3818 12.793 16.6667 12.6083",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.60832C14.0503 2.79191 14.6859 3.20891 15.1397 3.79358C15.5935 4.37826 15.8399 5.09735 15.8399 5.83749C15.8399 6.57763 15.5935 7.29672 15.1397 7.8814C14.6859 8.46607 14.0503 8.88307 13.3333 9.06666",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "adgen",
    width: 16,
    height: 16,
    viewBox: "0 0 22 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0969 6.90878V0.889776C15.0967 0.729973 15.0534 0.573198 14.9715 0.436029C14.8895 0.29886 14.7721 0.186396 14.6316 0.11053C14.4842 0.0285018 14.3163 -0.00921531 14.1481 0.00190616C13.9798 0.0130276 13.8183 0.0725153 13.683 0.173229L12.9044 0.809165C11.3053 2.13437 9.44532 3.10788 7.44555 3.6664L7.0339 3.78284H2.23725C1.6444 3.78449 1.07631 4.02094 0.6571 4.44052C0.237893 4.86009 0.00165304 5.42868 0 6.02205V9.98098C0.00167165 10.4058 0.123618 10.8214 0.3517 11.1797C0.579782 11.538 0.904655 11.8242 1.28865 12.0052V14.137C1.28865 14.6311 1.48476 15.1049 1.83384 15.4543C2.18292 15.8037 2.65637 16 3.15004 16C3.64371 16 4.11716 15.8037 4.46624 15.4543C4.81532 15.1049 5.01143 14.6311 5.01143 14.137V12.2202H7.06075L7.4366 12.3277C9.43986 12.8842 11.3031 13.8578 12.9044 15.1849L13.7277 15.8567C13.8679 15.951 14.0331 16.0009 14.202 16C14.3198 16.0008 14.4365 15.9782 14.5455 15.9335C14.6544 15.8888 14.7534 15.8228 14.8367 15.7395C14.9199 15.6562 14.9858 15.5571 15.0305 15.448C15.0752 15.339 15.0978 15.2221 15.0969 15.1043V9.08529C15.3507 9.03787 15.5799 8.90311 15.7448 8.70437C15.9097 8.50562 16 8.25539 16 7.99703C16 7.73867 15.9097 7.48845 15.7448 7.2897C15.5799 7.09096 15.3507 6.9562 15.0969 6.90878ZM4.11653 14.137C4.11653 14.3935 4.01471 14.6396 3.83345 14.821C3.6522 15.0024 3.40637 15.1043 3.15004 15.1043C2.89371 15.1043 2.64788 15.0024 2.46663 14.821C2.28538 14.6396 2.18355 14.3935 2.18355 14.137V12.2202H4.11653V14.137ZM6.65804 11.3245H2.23725C1.88203 11.3219 1.54209 11.1795 1.29091 10.9281C1.03973 10.6767 0.897475 10.3365 0.894898 9.98098V6.02205C0.894898 5.66572 1.03632 5.32399 1.28806 5.07203C1.5398 4.82007 1.88123 4.67852 2.23725 4.67852H6.65804V11.3245ZM13.4682 14.4952C11.7746 13.0845 9.80113 12.0496 7.67823 11.4589L7.55294 11.423V4.56208L7.68718 4.52626C9.80672 3.93845 11.7773 2.90652 13.4682 1.49884L14.202 0.889776L14.2468 15.1401L13.4682 14.4952Z",
    fill: "currentColor"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "adflow",
    viewBox: "0 0 22 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 12.138v-1.388c0-1.448-1.178-2.625-2.625-2.625-0.62 0-1.125-0.505-1.125-1.125v-1.138c0.871-0.311 1.5-1.135 1.5-2.112 0-1.241-1.009-2.25-2.25-2.25s-2.25 1.009-2.25 2.25c0 0.977 0.629 1.801 1.5 2.111v1.139c0 0.62-0.505 1.125-1.125 1.125-1.448 0-2.625 1.178-2.625 2.625v1.388c-0.871 0.311-1.5 1.135-1.5 2.112 0 1.241 1.009 2.25 2.25 2.25s2.25-1.009 2.25-2.25c0-0.977-0.629-1.801-1.5-2.112v-1.388c0-0.62 0.505-1.125 1.125-1.125 0.734 0 1.398-0.305 1.875-0.793 0.477 0.488 1.141 0.793 1.875 0.793 0.62 0 1.125 0.505 1.125 1.125v1.388c-0.871 0.311-1.5 1.135-1.5 2.112 0 1.241 1.009 2.25 2.25 2.25s2.25-1.009 2.25-2.25c0-0.977-0.629-1.801-1.5-2.112zM5.25 15c-0.414 0-0.75-0.337-0.75-0.75s0.336-0.75 0.75-0.75 0.75 0.337 0.75 0.75-0.336 0.75-0.75 0.75zM9 3c0.414 0 0.75 0.337 0.75 0.75s-0.336 0.75-0.75 0.75-0.75-0.337-0.75-0.75 0.336-0.75 0.75-0.75zM12.75 15c-0.414 0-0.75-0.337-0.75-0.75s0.336-0.75 0.75-0.75 0.75 0.337 0.75 0.75-0.336 0.75-0.75 0.75z"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "sentinel",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83398 17.6667C7.83398 17.6667 14.334 14.4667 14.334 9.66675V4.06675L7.83398 1.66675L1.33398 4.06675V9.66675C1.33398 14.4667 7.83398 17.6667 7.83398 17.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.63333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83398 6.4668V9.6668",
    stroke: "currentColor",
    strokeWidth: 1.63333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83398 12.8667H7.84198",
    stroke: "currentColor",
    strokeWidth: 1.63333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "electron-icon",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7219 5.70725C14.5693 5.56141 14.3636 5.46632 14.1288 5.44576C14.0965 5.44282 14.0638 5.44121 14.0307 5.44121V5.10733H14.0244V0H12.3485H3.30314H2.77967C1.80076 0 1 0.7097 1 1.57753V10.4225C1 11.29 1.80103 12 2.77967 12H3.30286H12.3485H13.9335V7.30882H14.0307V7.30348C14.0638 7.30348 14.0965 7.30187 14.1288 7.29867C14.3636 7.27837 14.5693 7.18381 14.7219 7.03717C14.8954 6.8713 15 6.63812 15 6.37261C14.9997 6.10738 14.8954 5.87419 14.7219 5.70725ZM11.2427 6.88839C11.219 7.18355 11.1763 7.45386 11.1146 7.69906C11.0532 7.94426 10.9673 8.16329 10.8583 8.35534C10.7489 8.54792 10.6085 8.71727 10.4378 8.86284C10.2874 8.98918 10.125 9.09122 9.95067 9.17055C9.77637 9.25041 9.59821 9.31185 9.41729 9.35512C9.2361 9.39785 9.05987 9.4267 8.88942 9.43899C8.71842 9.45261 8.56477 9.45929 8.42791 9.45929H4.90052V7.72844H7.04366C7.41265 7.72844 7.68967 7.71028 7.87416 7.67369C8.05865 7.63709 8.19551 7.60264 8.28445 7.56978C8.53696 7.47015 8.70465 7.33606 8.78699 7.16645C8.86877 6.99737 8.9065 6.83978 8.89961 6.69367H5.13678V5.12309H8.90016C8.85913 4.91715 8.78396 4.7649 8.67436 4.66554C8.56504 4.56591 8.46591 4.49299 8.37725 4.44678C8.19936 4.35383 8.01294 4.29399 7.81826 4.26755C7.62358 4.24111 7.40962 4.22749 7.17722 4.22749H4.99331V2.49744H8.42819C8.97506 2.49744 9.4195 2.56876 9.76122 2.71112C10.1029 2.85403 10.3662 3.01456 10.5507 3.19352C10.7214 3.35966 10.8547 3.55171 10.9505 3.77047C11.0463 3.98949 11.1177 4.21814 11.1658 4.45693C11.2135 4.69572 11.2443 4.94119 11.2581 5.19254C11.2719 5.44469 11.2785 5.68668 11.2785 5.91907C11.2787 6.27031 11.2669 6.59378 11.2427 6.88839Z",
    fill: "#0C8FCF"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "google_ads_st",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4144 14.2824L7.39111 3.98047C8.15022 4.43044 11.9781 6.56345 12.5957 6.96905L6.61958 17.271C5.9666 18.1403 0.587014 15.6017 1.4144 14.2824Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5997 14.2814L12.6237 3.97944C11.7882 2.58014 9.98881 2.07142 8.51092 2.89825C7.03304 3.72508 6.58304 5.50623 7.4185 6.96865L13.3946 17.2706C14.23 18.6699 16.0294 19.1786 17.5073 18.3517C18.9213 17.5249 19.4352 15.68 18.5997 14.2814Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9962 18.7503C5.65311 18.7503 6.9963 17.4316 6.9963 15.8048C6.9963 14.1781 5.65311 12.8594 3.9962 12.8594C2.33929 12.8594 0.996094 14.1781 0.996094 15.8048C0.996094 17.4316 2.33929 18.7503 3.9962 18.7503Z",
    fill: "#34A853"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "meta_st",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16756_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "url(#paint0_linear_16756_3600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1867 5.11707C11.9825 5.11707 11.0411 6.02413 10.1891 7.17636C9.15989 5.75072 8.04389 5.13754 6.99401 5.11966C6.95165 5.11801 6.9093 5.11707 6.86671 5.11707V5.12013C4.57024 5.18601 2.62224 8.08789 2.64671 11.5182C2.79895 15.8712 6.80389 16.1578 8.91283 11.6258C8.91283 11.6258 9.5533 10.4952 9.99354 9.71636C11.1801 11.6773 12.9509 15.2418 14.8025 14.8766C19.7025 14.499 16.6288 4.4573 13.1867 5.11707ZM7.74154 10.899C6.49636 12.8507 6.06577 13.2884 5.37236 13.2884C2.97095 13.0926 4.63518 6.0126 7.33848 6.77072C7.89589 6.95354 8.50812 7.53707 9.23212 8.55001L9.24271 8.56695C8.30789 10.0006 7.74154 10.899 7.74154 10.899ZM14.8359 13.2884C14.1267 13.2884 13.7879 12.8199 12.4411 10.6531C12.2182 10.282 11.894 9.73542 11.5787 9.21919L11.5801 9.21707C11.4758 9.04766 11.3738 8.88444 11.2742 8.72742C11.1401 8.51566 11.0154 8.32295 10.9093 8.17072C13.2025 4.23989 15.9385 7.43589 15.9331 11.5653C15.9328 12.6557 15.5757 13.2884 14.8359 13.2884Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16756_3600",
    x1: 2.92894,
    y1: 2.92894,
    x2: 17.0711,
    y2: 17.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#007AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16756_3600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "tiktok_st",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16756_3602)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.003 0C15.5236 0 20.006 4.47645 20.006 10.003C20.006 15.5236 15.5296 20.006 10.003 20.006C4.48245 20.006 0 15.5296 0 10.003C0 4.48245 4.47645 0 10.003 0ZM12.1692 4.46445C12.3552 6.0366 13.2313 6.9727 14.7495 7.06871V8.83288C13.8674 8.91689 13.0933 8.62886 12.1932 8.08881V11.3891C12.1932 15.5896 7.61476 16.8977 5.77858 13.8914C4.59646 11.9592 5.32253 8.55686 9.11491 8.42484V10.291C8.82688 10.339 8.52085 10.411 8.23882 10.5071C7.39274 10.7891 6.91869 11.3291 7.0507 12.2712C7.30873 14.0774 10.6211 14.6115 10.345 11.0831V4.47045H12.1752L12.1692 4.46445Z",
    fill: "#030712"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16756_3602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "yandex_direct_st",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.05422 17.1815C2.40057 16.5645 1.83935 15.8568 1.38786 15.08C0.379371 13.3692 -0.109874 11.5146 0.0207694 9.53764C0.267392 5.8385 2.00641 3.01707 5.26649 1.24036C8.21196 -0.36466 11.2654 -0.379965 14.3169 1.00879C15.0305 1.3405 15.6985 1.76228 16.3045 2.2638C16.3445 2.2964 16.4078 2.31504 16.3998 2.3869C16.3796 2.40981 16.3548 2.42827 16.327 2.4411C16.2993 2.45393 16.2691 2.46086 16.2385 2.46143C15.9006 2.52199 15.572 2.6238 15.2387 2.69167C14.3322 2.91326 13.4257 3.13685 12.5179 3.3571C12.3686 3.3957 12.2199 3.44028 12.0673 3.46757C12.0345 3.47105 12.0021 3.47774 11.9706 3.48753C11.9473 3.49485 11.9233 3.50017 11.8993 3.50549C11.8173 3.51952 11.7366 3.54021 11.658 3.56738C10.7535 3.77899 9.85434 4.00989 8.94983 4.22083C8.88318 4.23547 8.81186 4.25078 8.74454 4.27141C8.48991 4.33063 8.23863 4.40449 7.98267 4.45374C7.92468 4.46771 7.86603 4.47969 7.8087 4.49566C7.72605 4.51562 7.64207 4.53359 7.56075 4.5622C6.94819 4.71525 6.3323 4.85699 5.71975 5.01203C5.52622 5.06048 5.3385 5.12964 5.15985 5.21832C3.67611 5.95029 3.20153 7.8887 4.19802 9.17764C4.58195 9.67405 5.07453 10.0181 5.69975 10.1505C6.11829 10.2378 6.55115 10.2298 6.96619 10.1272C7.44477 10.0094 7.92268 9.89032 8.40193 9.77919C8.47792 9.76389 8.5539 9.74659 8.62856 9.72529C8.65281 9.71792 8.67753 9.71214 8.70254 9.70799C9.73902 9.46245 10.7688 9.20226 11.808 8.96004C11.88 8.94341 11.9826 8.88286 12.0233 8.96004C12.0733 9.05188 11.9513 9.0898 11.896 9.14304C11.4061 9.61683 10.8961 10.0693 10.3962 10.5305C9.879 11.0069 9.35509 11.476 8.84119 11.9558C8.81252 11.9831 8.7832 12.0104 8.75387 12.0363C8.64293 12.1155 8.5414 12.207 8.45125 12.3092C7.83937 12.8508 7.2468 13.4138 6.63891 13.9588C6.33097 14.2349 6.03236 14.5224 5.72441 14.7999C5.08519 15.3861 4.44731 15.9737 3.80476 16.556C3.61279 16.7303 3.42216 16.9073 3.23286 17.085C3.18087 17.1236 3.13954 17.1901 3.05422 17.1815Z",
    fill: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38086 19.857L9.23122 19.0545C9.27545 18.9952 9.32307 18.9386 9.37384 18.8848C9.38917 18.8682 9.40516 18.8529 9.42115 18.8369C9.4878 18.775 9.55444 18.7191 9.61708 18.6519C9.64108 18.6333 9.6664 18.6166 9.68973 18.5967C10.3048 18.0158 10.9333 17.4501 11.5557 16.8759C12.0955 16.3768 12.6413 15.885 13.1811 15.3853C13.3144 15.2615 13.4537 15.1431 13.581 15.0147C13.6274 14.9591 13.6905 14.9199 13.7609 14.9029L15.4937 13.3278L15.7762 13.0723C15.8155 13.1388 15.7762 13.1801 15.7616 13.224C15.2235 14.8259 14.6846 16.4274 14.1448 18.0284C14.0179 18.3896 13.9695 18.7737 14.0029 19.155C13.195 19.521 12.3389 19.7695 11.4604 19.8929C10.4932 20.0363 9.51005 20.0363 8.5428 19.8929C8.48815 19.8843 8.43484 19.869 8.38086 19.857Z",
    fill: "#1B4A7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7002 14.4923L16.7002 14.4921L16.7007 14.4922L16.7002 14.4923ZM16.7667 16.0037L16.7651 15.9995L16.77 15.9987L16.7667 16.0037ZM16.8925 17.2324L16.8926 17.2319L16.932 17.1932L16.9339 17.1864C16.9525 17.1792 16.9696 17.1684 16.9839 17.1545C16.9971 17.1418 17.0078 17.1269 17.0155 17.1104L17.0195 17.1076L17.026 17.1027C17.0799 17.0468 17.1346 16.9914 17.1892 16.9361C17.3122 16.8116 17.4352 16.687 17.5506 16.5557C17.8132 16.2576 18.0738 15.9568 18.2664 15.6054C18.2639 15.6014 18.2613 15.5976 18.2586 15.594L18.2617 15.5952C18.3039 15.5293 18.3465 15.4636 18.3891 15.398L18.3894 15.3976L18.3896 15.3973C18.4746 15.2662 18.5596 15.1351 18.6416 15.0023C18.9598 14.4938 19.2142 13.9481 19.399 13.3777L19.3993 13.3777L19.3989 13.3804L19.4009 13.3777L19.3993 13.3777L19.3995 13.3763L19.4015 13.37L19.4012 13.37C19.4548 13.2643 19.4949 13.1524 19.5207 13.0369L19.5221 13.0372L19.5281 13.0231L19.5281 13.023C19.5403 12.9943 19.5529 12.9648 19.5621 12.9294C20.0905 11.2099 20.1416 9.37948 19.71 7.63324C19.4992 6.73815 19.1554 5.87957 18.6902 5.08596L18.6827 5.08407C18.6119 4.93568 18.5264 4.79478 18.4274 4.66349L18.4274 4.65998L18.4021 4.61939L18.3966 4.62164C18.3969 4.61977 18.397 4.61795 18.397 4.61622C18.3871 4.5765 18.3648 4.54101 18.3334 4.51486C18.3241 4.47648 18.3015 4.44261 18.2697 4.41922L18.2637 4.4225L18.2637 4.41593C17.8575 3.79156 17.371 3.22309 16.8166 2.72506L16.8153 2.72802L16.758 2.67144L16.7573 2.67137L16.7607 2.66886L16.6322 2.55906L16.6287 2.56089C16.6154 2.54704 16.6026 2.53242 16.5899 2.51781L16.5898 2.51774L16.5897 2.51759C16.5371 2.45727 16.4847 2.39702 16.3928 2.39062C16.018 2.45572 15.6475 2.54355 15.2834 2.65363C15.2822 2.64352 15.2445 2.64442 15.2255 2.65947C15.1139 2.68533 15.0024 2.71075 14.8908 2.73617L14.8907 2.73619C14.6636 2.78795 14.4365 2.8397 14.2103 2.89503C13.7766 3.00139 13.3433 3.11004 12.91 3.21866L12.9097 3.21873L12.4955 3.32251L12.4953 3.3207L12.0287 3.4285L12.0278 3.42973C12.0168 3.42728 12.0054 3.42762 11.9946 3.43077C11.9831 3.43412 11.9727 3.44052 11.9646 3.44927L11.9621 3.44846L11.8954 3.46111L11.8948 3.46238C11.8227 3.46785 11.752 3.48476 11.6854 3.51245C11.6769 3.51427 11.6687 3.51721 11.6608 3.52166C11.5604 3.54485 11.4598 3.56756 11.359 3.59029C11.1706 3.63278 10.9819 3.67534 10.7943 3.72129L9.96521 3.92826C9.61959 4.01459 9.27388 4.10094 8.92796 4.18709L8.926 4.18896L8.92706 4.18731C8.86008 4.18781 8.79393 4.20208 8.7327 4.22923L8.73361 4.23024L8.732 4.22968C8.47235 4.28004 8.21558 4.34424 7.9628 4.42199L7.96252 4.42315L7.96189 4.42268C7.90347 4.41778 7.84493 4.43056 7.79389 4.45935C7.71151 4.46406 7.63081 4.48459 7.55621 4.51981V4.52018C7.04155 4.64099 6.52734 4.75936 6.01356 4.87531C5.97511 4.88453 5.93657 4.8935 5.89804 4.90246L5.8978 4.90252C5.63047 4.96471 5.36318 5.0269 5.12439 5.17342C5.12499 5.18041 5.12601 5.18734 5.12743 5.19417L5.12365 5.18573C5.01265 5.22138 4.90949 5.27784 4.8197 5.35209C4.22458 5.75118 3.81209 6.36941 3.67255 7.07145C3.53301 7.77348 3.67778 8.50211 4.07517 9.09781C4.25356 9.37527 4.48576 9.61429 4.75808 9.8008C5.03041 9.9873 5.33737 10.1175 5.66088 10.1838L5.6588 10.1713L5.66296 10.1755C5.91234 10.2545 6.17606 10.2779 6.43549 10.244C6.91273 10.1955 7.37458 10.074 7.83641 9.95247C8.03314 9.90071 8.22987 9.84895 8.4278 9.80284C8.4265 9.79998 8.42484 9.79701 8.42304 9.79397L8.43205 9.79802L8.63285 9.74478L8.63258 9.75328L8.69781 9.7413C8.69818 9.73804 8.69913 9.73493 8.70051 9.73194L8.70067 9.73214L12.0481 8.93362L11.7364 9.21927L11.7349 9.22062L11.73 9.22511C11.4247 9.5049 11.1328 9.77239 10.8416 10.0402C10.1577 10.6706 9.47364 11.301 8.78932 11.9314C8.78949 11.9347 8.78949 11.9377 8.78934 11.9407L8.78572 11.9379C8.76975 11.9436 8.75509 11.9523 8.74262 11.9638C8.73184 11.9737 8.7229 11.9853 8.71617 11.9983C8.60929 12.0749 8.5121 12.1642 8.42672 12.2641L8.43098 12.27L8.42676 12.271L8.1 12.5661C7.79865 12.8381 7.49725 13.1101 7.19765 13.3843C6.83485 13.7166 6.47275 14.0511 6.11085 14.3853L5.69659 14.7677L5.69646 14.7686L5.6944 14.7672C5.63172 14.8221 5.56792 14.8756 5.50417 14.929L5.50408 14.9291L5.50397 14.9292C5.45796 14.9678 5.41198 15.0063 5.36646 15.0454C4.59327 15.7578 3.82007 16.469 3.04688 17.1788C3.47772 17.6087 3.95244 17.9926 4.46329 18.324C5.04389 18.7182 5.66968 19.0416 6.32729 19.2873L6.33114 19.2927C6.98833 19.5651 7.67785 19.752 8.38277 19.849C8.70308 19.6173 8.9966 19.3508 9.25795 19.0545C9.26255 19.0451 9.26622 19.0361 9.26902 19.0275C9.31932 18.9914 9.36366 18.9475 9.40034 18.8974L9.40154 18.8977L9.43282 18.8665L9.43246 18.8655C9.51107 18.8159 9.58021 18.7527 9.63667 18.6789L9.63742 18.6792L9.69666 18.6267L9.69692 18.622C9.71655 18.6091 9.73554 18.5952 9.75381 18.5804C10.5021 17.8968 11.2495 17.212 11.9961 16.5262C12.5818 15.9854 13.1676 15.4447 13.7538 14.9039L13.7473 14.8916C13.7435 14.8842 13.74 14.8768 13.7368 14.8695C13.7471 14.8854 13.7586 14.9013 13.771 14.9174C13.8247 14.918 13.8593 14.8854 13.8936 14.8531L13.911 14.8369C14.3381 14.4509 14.7629 14.0623 15.1855 13.671C15.3581 13.51 15.5301 13.349 15.7114 13.1773C15.7141 13.2377 15.701 13.2978 15.6734 13.3516C15.4205 14.1162 15.1613 14.8794 14.902 15.6428C14.6344 16.4308 14.3667 17.2191 14.1057 18.0097C14.0312 18.2124 13.9837 18.4241 13.9643 18.6392C13.9622 18.6762 13.9581 18.7135 13.954 18.7509L13.954 18.7511C13.939 18.8874 13.9238 19.0254 14.0017 19.1549C14.6105 18.9005 15.1885 18.5782 15.7247 18.194C16.1461 17.9145 16.5374 17.5922 16.8925 17.2324ZM11.88 3.48499C11.8848 3.47918 11.8894 3.4724 11.8936 3.46451C11.8872 3.47088 11.8829 3.47774 11.88 3.48499ZM7.52651 5.56737C7.55006 5.55891 7.56021 5.54619 7.56438 5.53169C7.54957 5.54787 7.53727 5.55978 7.52651 5.56737ZM12.6696 4.76809L12.666 4.77134C12.666 4.77134 12.6718 4.79378 12.6755 4.79845C12.6732 4.78829 12.6713 4.77817 12.6696 4.76809ZM12.6793 5.87005C12.6656 5.86656 12.6512 5.86229 12.636 5.85733L12.6615 5.88317C12.6659 5.87855 12.6718 5.87419 12.6793 5.87005ZM12.8644 7.25777L12.8613 7.25873C12.8469 7.26089 12.8332 7.2666 12.8216 7.27535C12.8194 7.27702 12.8173 7.27881 12.8152 7.28068C12.8345 7.27433 12.8507 7.26661 12.8644 7.25777ZM13.3807 13.2495C13.3769 13.2494 13.3731 13.2495 13.3692 13.2496L13.3702 13.2609C13.3722 13.258 13.3745 13.2553 13.3771 13.2528L13.3807 13.2495ZM18.5062 5.1046L18.5074 5.10992L18.5033 5.10609L18.5062 5.1046ZM18.0831 14.6855C18.08 14.6892 18.0772 14.6929 18.0746 14.6965C18.0725 14.6926 18.0705 14.6891 18.0684 14.6859C18.0731 14.6857 18.0779 14.6855 18.0831 14.6855ZM17.6825 10.5392L17.6738 10.5322L17.6785 10.5299L17.6825 10.5392ZM15.4993 2.86986L15.5026 2.86759L15.5023 2.87173L15.4993 2.86986ZM15.5304 2.88961C15.5258 2.88812 15.5214 2.88614 15.5173 2.88372C15.5249 2.8871 15.5336 2.88816 15.5425 2.88901L15.5495 2.89287C15.543 2.89272 15.5366 2.89163 15.5304 2.88961ZM15.5986 3.37075L15.5974 3.37481C15.5938 3.38192 15.5905 3.3892 15.5873 3.3966L15.5946 3.39322L15.5995 3.39132C15.5994 3.38447 15.5993 3.37758 15.5986 3.37075ZM15.6188 4.30406L15.617 4.33171C15.6205 4.32241 15.6209 4.31326 15.6188 4.30406ZM15.7571 4.91627L15.7576 4.91462L15.7589 4.91594L15.7571 4.91627ZM16.4232 11.2573L16.4349 11.2413L16.4381 11.2369L16.4257 11.2396L16.4169 11.2413C16.4183 11.2439 16.4196 11.2464 16.4206 11.2491C16.4217 11.2518 16.4225 11.2545 16.4232 11.2573ZM16.2585 9.8896C16.2631 9.88394 16.2665 9.87772 16.2685 9.87077C16.2655 9.87712 16.2622 9.88341 16.2585 9.8896ZM16.0122 6.69464C16.0034 6.69877 15.9949 6.69944 15.9866 6.69799C15.9928 6.69018 16.0003 6.6827 16.0094 6.67564C16.0102 6.67908 16.0109 6.68271 16.0114 6.68655L16.0122 6.69464ZM9.00649 15.7523L9.00782 15.7483L9.01528 15.7516L9.00649 15.7523Z",
    fill: "#FEDF14"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "vk_ads_st",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.50794C0 5.02637 0 2.78119 1.3928 1.39279C2.7812 0 5.02636 0 9.50789 0H10.4921C14.9737 0 17.2145 0 18.6072 1.39279C20 2.7856 20 5.02637 20 9.50794V10.4921C20 14.9737 20 17.2145 18.6072 18.6073C17.2145 20 14.9737 20 10.4921 20H9.50789C5.02636 20 2.78559 20 1.3928 18.6073C0 17.2145 0 14.9737 0 10.4921V9.50794Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96114 16.4848C13.5645 16.4848 16.4857 13.5636 16.4857 9.96014C16.4857 6.3567 13.5645 3.43555 9.96114 3.43555C6.35769 3.43555 3.43652 6.3567 3.43652 9.96014C3.43652 13.5636 6.35769 16.4848 9.96114 16.4848Z",
    fill: "#00D3E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0354 2.64067V3.89287H17.2701C17.9732 3.89287 18.3334 4.73645 17.8457 5.24173L16.1542 7.00799C16.0047 7.16618 15.7939 7.25406 15.5786 7.25406H13.9793L12.3228 9.03787C12.4415 9.32343 12.5118 9.63981 12.5118 9.96931C12.5118 11.2919 11.4397 12.3639 10.1172 12.3639C8.79472 12.3639 7.72266 11.2919 7.72266 9.96931C7.72266 8.64681 8.79472 7.5748 10.1172 7.5748C10.3413 7.5748 10.561 7.60556 10.7675 7.66262L12.6699 5.61519V4.30148C12.6699 4.08179 12.7622 3.8709 12.9204 3.72151L14.6866 2.05631C15.1963 1.5774 16.0311 1.93768 16.0311 2.63627L16.0354 2.64067Z",
    fill: "white"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "ybusiness",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#323556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45818 11.68V4.23273H10.1018V5.2H6.58182V7.23636H8.24727C8.8 7.23636 9.26909 7.32606 9.65455 7.50545C10.0424 7.68485 10.3382 7.93818 10.5418 8.26545C10.7479 8.59273 10.8509 8.97818 10.8509 9.42182C10.8509 9.86545 10.7479 10.257 10.5418 10.5964C10.3382 10.9358 10.0424 11.2012 9.65455 11.3927C9.26909 11.5842 8.8 11.68 8.24727 11.68H5.45818ZM6.58182 10.7345H8.24727C8.56727 10.7345 8.83758 10.6715 9.05818 10.5455C9.28121 10.4194 9.4497 10.2558 9.56364 10.0545C9.68 9.85333 9.73818 9.63758 9.73818 9.40727C9.73818 9.07273 9.6097 8.78545 9.35273 8.54545C9.09576 8.30303 8.72727 8.18182 8.24727 8.18182H6.58182V10.7345Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "ynavigator",
    viewBox: "0 0 22 23",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17545_315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75189 11.2531L11.8772 20L20 0L0 8.12783L8.75189 11.2531Z",
    fill: "url(#paint0_linear_17545_315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8771 20L19.9999 0L8.43982 11.5652L11.8771 20Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6241 9.37595L0 8.12784L8.12783 11.8772L11.8772 20L10.6241 9.37595Z",
    fill: "#ECA704"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17545_315",
    x1: 0.00827587,
    y1: 20.0076,
    x2: 20.0091,
    y2: 0.00671223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE992"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17545_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "google_ads_transactions",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17502_5227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.892 4.02963C11.2013 3.14106 11.6266 2.323 12.258 1.6601C14.7839 -1.03384 18.9593 -0.356826 20.6733 3.02822C21.962 5.59522 23.3281 8.1058 24.6554 10.6446C26.872 14.8618 29.1144 19.079 31.3052 23.3103C33.148 26.8505 31.1505 31.3216 27.4906 31.9281C25.2482 32.2948 23.1476 31.1664 21.9878 28.9662C20.0418 25.2567 18.083 21.5473 16.137 17.8519C16.0984 17.7673 16.0468 17.6968 15.9953 17.6262C15.7891 17.4429 15.6989 17.1749 15.57 16.9351C14.7066 15.2708 13.8174 13.6206 12.9539 11.9704C12.3998 10.8985 11.8199 9.84063 11.2657 8.7687C10.7631 7.8096 10.5311 6.76588 10.5569 5.66574C10.5956 5.10156 10.66 4.53739 10.892 4.02963Z",
    fill: "#3C8BD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8903 4.02972C10.7743 4.53748 10.6712 5.04524 10.6454 5.5812C10.6068 6.76597 10.8774 7.86611 11.4186 8.89573C12.8362 11.5615 14.2538 14.2413 15.6585 16.9211C15.7874 17.1609 15.8905 17.4007 16.0193 17.6263C15.2461 19.0932 14.4729 20.5459 13.6868 22.0128C12.6043 24.0579 11.5217 26.1172 10.4263 28.1623C10.3748 28.1623 10.3619 28.1341 10.349 28.0918C10.3361 27.9789 10.3748 27.8802 10.4006 27.7674C10.9289 25.6517 10.4908 23.7758 9.1634 22.1679C8.35151 21.1947 7.32054 20.6447 6.13492 20.4613C4.58847 20.2215 3.22243 20.6588 1.99816 21.7166C1.77908 21.9 1.63732 22.1679 1.37958 22.309C1.32803 22.309 1.30225 22.2808 1.28937 22.2385C1.90795 21.0678 2.51364 19.8971 3.13223 18.7265C5.68387 13.8746 8.23552 9.02267 10.8001 4.18487C10.8258 4.12845 10.8645 4.08614 10.8903 4.02972Z",
    fill: "#FABC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34028 22.2807C1.58514 22.0409 1.8171 21.787 2.07485 21.5614C5.20642 18.8533 9.91021 20.8138 10.5932 25.1016C10.7608 26.1312 10.6706 27.1185 10.387 28.1058C10.3741 28.1904 10.3613 28.2609 10.3355 28.3456C10.2195 28.5712 10.1164 28.811 9.98754 29.0367C8.84058 31.11 7.15237 32.1396 4.93579 31.9845C2.39702 31.787 0.399521 29.6996 0.0515683 26.9351C-0.115964 25.5952 0.128891 24.3399 0.76036 23.1834C0.889231 22.9295 1.04388 22.7038 1.18563 22.4499C1.25007 22.3935 1.2243 22.2807 1.34028 22.2807Z",
    fill: "#34A852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33938 22.2795C1.28783 22.3359 1.28783 22.4346 1.19762 22.4488C1.18473 22.35 1.23628 22.2936 1.28783 22.2231L1.33938 22.2795Z",
    fill: "#FABC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3342 28.3457C10.2826 28.2469 10.3342 28.1764 10.3857 28.1059C10.3986 28.12 10.4244 28.1482 10.4373 28.1623L10.3342 28.3457Z",
    fill: "#E1C025"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17502_5227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "yandex_direct_transactions",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17502_5234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 11.7565 1.68571 7.68687 4.68629 4.68629C7.68687 1.68571 11.7565 0 16 0C20.2435 0 24.3131 1.68571 27.3137 4.68629C30.3143 7.68687 32 11.7565 32 16C32 20.2435 30.3143 24.3131 27.3137 27.3137C24.3131 30.3143 20.2435 32 16 32C11.7565 32 7.68687 30.3143 4.68629 27.3137C1.68571 24.3131 0 20.2435 0 16Z",
    fill: "#1A4A7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.384 31.784C10.1771 31.2572 7.2074 29.764 4.87201 27.504L19.288 14.272L11.048 16.272C10.5026 16.4061 9.9359 16.4302 9.38104 16.343C8.82618 16.2558 8.29422 16.0591 7.81617 15.7642C7.33813 15.4693 6.92356 15.0823 6.59664 14.6255C6.26972 14.1688 6.03699 13.6516 5.91201 13.104C5.65865 11.9898 5.85285 10.8206 6.45281 9.84808C7.05277 8.87557 8.01054 8.17747 9.12001 7.90399L26.272 3.73599C28.3609 5.48517 29.9686 7.73881 30.9426 10.2833C31.9166 12.8278 32.2248 15.5789 31.8378 18.2759C31.4508 20.9728 30.3815 23.5263 28.7313 25.6942C27.081 27.8622 24.9045 29.5728 22.408 30.664C22.36 30.096 22.416 29.504 22.616 28.928L25.336 20.816L13.384 31.784Z",
    fill: "url(#paint0_linear_17502_5234)"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17502_5234",
    x1: 39.248,
    y1: 2.02399,
    x2: -15.528,
    y2: 52.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF11D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17502_5234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "tiktok_transactions",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5295 6.18232C25.7066 7.43064 27.1743 8.1913 28.6534 8.53753V7.60021C27.2636 7.49884 25.8095 7.04908 24.5295 6.18232ZM16.0274 0V20.9612C16.0274 23.7073 14.1086 25.4737 11.7753 25.4737C11.0013 25.4737 10.2663 25.2877 9.62738 24.9438C10.438 26.0084 11.718 26.6208 13.1217 26.6208C15.455 26.6208 17.3739 24.8544 17.3739 22.1058V1.14458H21.0719C20.9687 0.768127 20.8861 0.385995 20.8246 0H16.0274ZM12.9935 12.1857V11.147C12.5263 11.067 12.0592 11.0411 11.6722 11.0411C6.40798 11.0411 2 15.3865 2 20.7751C2 24.3127 3.6739 27.3366 6.21786 29.1266C4.44559 27.3179 3.34647 24.7861 3.34647 21.9198C3.34647 16.5405 7.74067 12.1975 12.9935 12.1857Z",
    fill: "#2DCCD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3674 20.6149C21.3674 27.3083 16.3895 30.8554 11.6976 30.8554C9.66648 30.8554 7.77968 30.2241 6.21802 29.1266C7.97201 30.9165 10.3855 31.9999 13.0439 31.9999C17.7358 31.9999 22.7139 28.453 22.7139 21.7595V10.8526C22.2468 10.5276 21.7979 10.1485 21.3674 9.70568V20.6149ZM9.62763 24.9438C9.05515 24.1996 8.71394 23.2363 8.71394 22.1058C8.71394 18.9333 11.1251 17.2565 14.34 17.605V12.2917C13.873 12.2116 13.4058 12.1857 13.0165 12.1857H12.9936V16.458C9.77872 16.1118 7.36747 17.7864 7.36747 20.9612C7.36747 22.817 8.29035 24.2254 9.62763 24.9438ZM28.6537 8.53747V12.506C26.5173 12.506 24.4954 12.0868 22.7139 10.8526C24.7884 12.9865 27.3049 13.653 30.0001 13.653V8.74474C29.5465 8.71345 29.0963 8.64413 28.6537 8.53747ZM24.5297 6.18227C23.3916 4.97883 22.5238 3.32072 22.1712 1.14453H21.0721C21.6995 3.49737 22.9909 5.13896 24.5297 6.18227Z",
    fill: "#F1204A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6975 30.8554C16.3893 30.8554 21.3673 27.3083 21.3673 20.6149V9.70568C21.7979 10.1485 22.2467 10.5276 22.7138 10.8526C24.4953 12.0868 26.5172 12.506 28.6536 12.506V8.53747C27.1743 8.19125 25.7065 7.43049 24.5296 6.18237C22.9908 5.13896 21.6994 3.49737 21.072 1.14453H17.3739V22.1058C17.3739 24.8543 15.455 26.6207 13.1217 26.6207C11.718 26.6207 10.4381 26.0084 9.62744 24.9438C8.29025 24.2254 7.36747 22.817 7.36747 20.9612C7.36747 17.7864 9.77862 16.1118 12.9935 16.458V12.1857C7.74064 12.1975 3.34644 16.5404 3.34644 21.9196C3.34644 24.786 4.44556 27.3178 6.21801 29.1266C7.77958 30.2241 9.66638 30.8554 11.6975 30.8554Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "meta_transactions",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17502_5251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "url(#paint0_linear_17502_5251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0987 8.18653C19.172 8.18653 17.6657 9.63782 16.3025 11.4814C14.6558 9.20036 12.8702 8.21928 11.1904 8.19067C11.1226 8.18803 11.0549 8.18653 10.9867 8.18653V8.19142C7.31239 8.29684 4.19559 12.9398 4.23474 18.4284C4.47832 25.3931 10.8862 25.8517 14.2605 18.6005C14.2605 18.6005 15.2853 16.7915 15.9897 15.5454C17.8882 18.6829 20.7215 24.3861 23.684 23.8018C31.524 23.1975 26.6061 7.13091 21.0987 8.18653ZM12.3865 17.4375C10.3942 20.5604 9.70523 21.2606 8.59578 21.2606C4.75352 20.9474 7.41629 9.61938 11.7416 10.8324C12.6334 11.1249 13.613 12.0585 14.7714 13.6792L14.7883 13.7063C13.2926 16.0002 12.3865 17.4375 12.3865 17.4375ZM23.7374 21.2606C22.6027 21.2606 22.0606 20.511 19.9057 17.0441C19.5492 16.4504 19.0304 15.5759 18.5259 14.7499L18.5282 14.7465C18.3613 14.4755 18.1982 14.2143 18.0388 13.9631C17.8242 13.6243 17.6247 13.3159 17.4549 13.0724C21.124 6.78305 25.5016 11.8966 25.4929 18.5037C25.4925 20.2483 24.921 21.2606 23.7374 21.2606Z",
    fill: "white"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17502_5251",
    x1: 4.68631,
    y1: 4.68631,
    x2: 27.3137,
    y2: 27.3137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#007AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17502_5251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "telegram_transactions",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17502_5237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 2.74126L0.832503 13.9556C0.815261 13.9623 0.798546 13.9702 0.782503 13.9794C0.547503 14.1125 -1.0925 15.1156 1.22 16.015L1.24375 16.0238L8.14438 18.2531C8.19703 18.2702 8.25278 18.2756 8.30772 18.2689C8.36267 18.2622 8.4155 18.2436 8.4625 18.2144L25.5781 7.53564C25.6201 7.50945 25.6668 7.49182 25.7156 7.48376C25.9538 7.44439 26.6394 7.37064 26.2056 7.92126C25.715 8.54626 14.0244 19.0225 12.7269 20.1844C12.6521 20.2516 12.6058 20.3448 12.5975 20.445L12.0313 27.195C12.0312 27.2638 12.0471 27.3316 12.0778 27.3931C12.1085 27.4546 12.1531 27.5081 12.2081 27.5494C12.2861 27.5985 12.3779 27.6213 12.4698 27.6143C12.5618 27.6073 12.649 27.571 12.7188 27.5106L16.8188 23.8463C16.8835 23.7884 16.9661 23.7544 17.0529 23.75C17.1396 23.7456 17.2253 23.7709 17.2956 23.8219L24.4488 29.0156L24.4719 29.0313C24.645 29.1381 26.515 30.2263 27.055 27.7963L31.9925 4.31814C31.9994 4.24376 32.0662 3.42626 31.4819 2.94314C30.8681 2.43814 29.9994 2.69314 29.8688 2.72064C29.8495 2.726 29.8307 2.7329 29.8125 2.74126Z",
    fill: "#009EEB"
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17502_5237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "vk_ads_transactions",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17502_5239)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17502_5239",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17502_5239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.36C0 8.11923 0 4.49885 2.24942 2.24942C4.49885 0 8.11923 0 15.36 0H16.64C23.8808 0 27.5012 0 29.7506 2.24942C32 4.49885 32 8.11923 32 15.36V16.64C32 23.8808 32 27.5012 29.7506 29.7506C27.5012 32 23.8808 32 16.64 32H15.36C8.11923 32 4.49885 32 2.24942 29.7506C0 27.5012 0 23.8808 0 16.64V15.36Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.24 16C26.24 21.6554 21.6554 26.24 16 26.24C10.3446 26.24 5.76001 21.6554 5.76001 16C5.76001 10.3446 10.3446 5.76001 16 5.76001C21.6554 5.76001 26.24 10.3446 26.24 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5621 8.88932C29.3398 8.11168 28.8395 6.7802 27.7422 6.70704L25.4128 6.57015L25.3138 4.27866C25.2407 3.18139 23.9092 2.6811 23.1315 3.45872L20.1297 6.46048C19.784 6.80621 19.6154 7.29101 19.6719 7.77668L19.921 9.91915L17.4134 12.4268C16.9751 12.2527 16.4971 12.157 15.9968 12.157C13.876 12.157 12.1568 13.8762 12.1568 15.997C12.1568 18.1177 13.876 19.837 15.9968 19.837C18.1176 19.837 19.8368 18.1177 19.8368 15.997C19.8368 15.5565 19.7627 15.1334 19.6261 14.7394L22.1838 12.1818L24.2442 12.349C24.7299 12.4055 25.2146 12.2368 25.5604 11.8911L28.5621 8.88932Z",
    fill: "black"
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17502_5239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("symbol", {
    id: "empty_wallet_transactions",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 6.66665V4.16665C14.1668 3.94563 14.079 3.73367 13.9228 3.57739C13.7665 3.42111 13.5545 3.33331 13.3335 3.33331H5.00016C4.55814 3.33331 4.13421 3.50891 3.82165 3.82147C3.50909 4.13403 3.3335 4.55795 3.3335 4.99998M3.3335 4.99998C3.3335 5.44201 3.50909 5.86593 3.82165 6.17849C4.13421 6.49105 4.55814 6.66665 5.00016 6.66665H15.0002C15.2212 6.66665 15.4331 6.75444 15.5894 6.91072C15.7457 7.067 15.8335 7.27897 15.8335 7.49998V9.99998M3.3335 4.99998V15C3.3335 15.442 3.50909 15.8659 3.82165 16.1785C4.13421 16.4911 4.55814 16.6666 5.00016 16.6666H15.0002C15.2212 16.6666 15.4331 16.5788 15.5894 16.4226C15.7457 16.2663 15.8335 16.0543 15.8335 15.8333V13.3333",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 10V13.3333H13.3332C12.8911 13.3333 12.4672 13.1577 12.1547 12.8452C11.8421 12.5326 11.6665 12.1087 11.6665 11.6667C11.6665 11.2246 11.8421 10.8007 12.1547 10.4882C12.4672 10.1756 12.8911 10 13.3332 10H16.6665Z",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpriteicons);
export default __webpack_public_path__ + "static/media/sprite.icons.ccc222a19526acd7c4ed23e05f9a678b.svg";
export { ForwardRef as ReactComponent };